
export const SegType = [
  {
    label_en: "Intro",
    label_es: "intro",
    label_pt: "intro",
    label_ko: "인트로",
    label_ja: "イントロ",
    label_de: "intro",
    label_it: "intro",
    label_fr: "intro",
    label_ru: "интро",
    "label_zh-Hans": "前奏",
    "label_zh-Hant": "前奏",
    label_cn: "前奏",
    value: "Intro",
  },
  {
    label_en: "Verse",
    label_es: "estrofa",
    label_pt: "verso",
    label_ko: "벌스",
    label_ja: "バース",
    label_de: "strophe",
    label_it: "strofa",
    label_fr: "couplet",
    label_ru: "куплет",
    "label_zh-Hans": "主歌",
    "label_zh-Hant": "主歌",
    label_cn: "主歌",
    value: "Verse",
  },
  {
    label_en: "Pre-Chorus",
    label_es: "pre-estribillo",
    label_pt: "pré-refrão",
    label_ko: "프리코러스",
    label_ja: "プレコーラス",
    label_de: "pre-refrain",
    label_it: "pre-ritornello",
    label_fr: "pré-refrain",
    label_ru: "пре-припев",
    "label_zh-Hans": "预副歌",
    "label_zh-Hant": "預副歌",
    label_cn: "预副歌",
    value: "Pre-Chorus",
  },
  {
    label_en: "Chorus",
    label_es: "estribillo",
    label_pt: "refrão",
    label_ko: "코러스",
    label_ja: "サビ",
    label_de: "refrain",
    label_it: "ritornello",
    label_fr: "refrain",
    label_ru: "припев",
    "label_zh-Hans": "副歌",
    "label_zh-Hant": "副歌",
    label_cn: "副歌",
    value: "Chorus",
  },
  {
    label_en: "Break",
    label_es: "break",
    label_pt: "break",
    label_ko: "브레이크",
    label_ja: "ブレイク",
    label_de: "break",
    label_it: "break",
    label_fr: "break",
    label_ru: "брейк",
    'label_zh-Hans': "间奏",
    'label_zh-Hant': "間奏",
    label_cn: "间奏",
    value: "Break",
  },
  {
    label_en: "Bridge",
    label_es: "puente",
    label_pt: "ponte",
    label_ko: "브리지",
    label_ja: "ブリッジ",
    label_de: "brücke",
    label_it: "ponte",
    label_fr: "pont",
    label_ru: "бридж",
    "label_zh-Hans": "桥段",
    "label_zh-Hant": "橋段",
    label_cn: "桥段",
    value: "Bridge",
  },
  {
    label_en: "Outro",
    label_es: "outro",
    label_pt: "outro",
    label_ko: "아웃트로",
    label_ja: "アウトロ",
    label_de: "outro",
    label_it: "outro",
    label_fr: "outro",
    label_ru: "аутро",
    "label_zh-Hans": "尾奏",
    "label_zh-Hant": "尾奏",
    label_cn: "尾奏",
    value: "Outro",
  },
];

export const getSegTypes = () => {
  return SegType;
};
// 生成-曲风-英文
const StyleLabelDataEN = {
  list: [
    {
      "en": "pop",
      "cn": "流行",
      "es": "estallido",
      "pt": "pop",
      "ko": "팝",
      "ja": "ポップ",
      'zh-Hans': "流行",
      'zh-Hant': "流行",
      "de": "pop",
      "fr": "pop",
      "it": "pop",
      "ru": "Поп-музыка",
    },
    {
      "en": "r&b",
      "cn": "节奏布鲁斯",
      "es": "R&B",
      "pt": "R&B",
      "ko": "알앤비",
      "ja": "R&B",
      'zh-Hans': "节奏布鲁斯",
      'zh-Hant': "節奏藍調",
      "de": "R&B",
      "fr": "R&B",
      "it": "R&B",
      "ru": "R&B",
    },
    {
      "en": "rock",
      "cn": "摇滚",
      "es": "roca",
      "pt": "pedra",
      "ko": "바위",
      "ja": "ロック",
      'zh-Hans': "摇滚",
      'zh-Hant': "搖滾",
      "de": "rock",
      "fr": "rock",
      "it": "roccia",
      "ru": "рок",
    },
    {
      "en": "disco",
      "cn": "迪斯科",
      "es": "disco",
      "pt": "discoteca",
      "ko": "디스코",
      "ja": "ディスコ",
      'zh-Hans': "迪斯科",
      'zh-Hant': "迪斯科",
      "de": "disco",
      "fr": "disco",
      "it": "disco",
      "ru": "диско",
    },
    {
      "en": "electronic",
      "cn": "电子",
      "es": "electrónico",
      "pt": "eletrônico",
      "ko": "전자",
      "ja": "電子",
      'zh-Hans': "电子",
      'zh-Hant': "電子",
      "de": "Electro",
      "fr": "électronique",
      "it": "Elettronica",
      "ru": "Электроника",
    },
    {
      "en": "folk",
      "cn": "民谣",
      "es": "gente",
      "pt": "povo",
      "ko": "사람들",
      "ja": "フォーク",
      'zh-Hans': "民谣",
      'zh-Hant': "民謠",
      "de": "Volkslied",
      "fr": "folk",
      "it": "folk",
      "ru": "Фолк",
    },
    {
      "en": "funk",
      "cn": "放克",
      "es": "canguelo",
      "pt": "funk",
      "ko": "펑키 재즈",
      "ja": "ファンク",
      'zh-Hans': "放克",
      'zh-Hant': "放克",
      "de": "funk",
      "fr": "funk",
      "it": "funk",
      "ru": "фанк",
    },
    {
      "en": "country",
      "cn": "乡村",
      "es": "país",
      "pt": "país",
      "ko": "국가",
      "ja": "国",
      'zh-Hans': "乡村",
      'zh-Hant': "鄉村",
      "de": "country",
      "fr": "country",
      "it": "country",
      "ru": "Кантри",
    },
    {
      "en": "hip-hop",
      "cn": "嘻哈",
      "es": "hip-hop",
      "pt": "hip-hop",
      "ko": "힙합",
      "ja": "ヒップホップ",
      'zh-Hans': "嘻哈",
      'zh-Hant': "嘻哈",
      "de": "hip-hop",
      "fr": "hip-hop",
      "it": "hip-hop",
      "ru": "хип-хоп",
    },
    {
      "en": "jazz",
      "cn": "爵士",
      "es": "jazz",
      "pt": "jazz",
      "ko": "재즈",
      "ja": "ジャズ",
      'zh-Hans': "爵士",
      'zh-Hant': "爵士",
      "de": "jazz",
      "fr": "jazz",
      "it": "jazz",
      "ru": "джаз",
    },
    {
      "en": "latin",
      "cn": "拉丁",
      "es": "latín",
      "pt": "latim",
      "ko": "라틴어",
      "ja": "ラテン",
      'zh-Hans': "拉丁",
      'zh-Hant': "拉丁",
      "de": "Latino",
      "fr": "latino",
      "it": "latina",
      "ru": "Латино"
    },
    {
      "en": "metal",
      "cn": "金属",
      "es": "metal",
      "pt": "metal",
      "ko": "금속",
      "ja": "金属",
      'zh-Hans': "金属",
      'zh-Hant': "金屬",
      "de": "metal",
      "fr": "métal",
      "it": "metal",
      "ru": "Метал",
    },
    {
      "en": "blues",
      "cn": "布鲁斯",
      "es": "blues",
      "pt": "blues",
      "ko": "블루스",
      "ja": "ブルース",
      'zh-Hans': "布鲁斯",
      'zh-Hant': "布鲁斯",
      "de": "blues",
      "fr": "blues",
      "it": "blues",
      "ru": "Блюз",
    },
    {
      "en": "punk",
      "cn": "朋克",
      "es": "punk",
      "pt": "punk",
      "ko": "펑크",
      "ja": "パンク",
      'zh-Hans': "朋克",
      'zh-Hant': "龐克",
      "de": "punk",
      "fr": "punk",
      "it": "punk",
      "ru": "Панк",
    },
    {
      "en": "reggae",
      "cn": "雷鬼",
      "es": "reggae",
      "pt": "reggae",
      "ko": "레게",
      "ja": "レゲエ",
      'zh-Hans': "雷鬼",
      'zh-Hant': "雷鬼",
      "de": "reggae",
      "fr": "reggae",
      "it": "reggae",
      "ru": "регги",
    },
    {
      "en": "soul",
      "cn": "灵魂",
      "es": "alma",
      "pt": "alma",
      "ko": "영혼",
      "ja": "魂",
      'zh-Hans': "灵魂",
      'zh-Hant': "靈魂",
      "de": "soul",
      "fr": "soul",
      "it": "soul",
      "ru": "Соул",
    },
    {
      "en": "indian",
      "cn": "印度风",
      "es": "indio",
      "pt": "indiano",
      "ko": "옥수수",
      "ja": "インド人",
      'zh-Hans': "印度风",
      'zh-Hant': "印度風",
      "de": "indisch",
      "fr": "indien",
      "it": "Musica indiana",
      "ru": "Индийская музыка",
    },
    {
      "en": "afrobeat",
      "cn": "非洲节拍",
      "es": "afrobeat",
      "pt": "afrobeat",
      "ko": "아프로비트",
      "ja": "アフロビート",
      'zh-Hans': "非洲节拍",
      'zh-Hant': "非洲節拍",
      "de": "afrobeat",
      "fr": "afrobeat",
      "it": "Ritmi africani",
      "ru": "Африканские ритмы",
    },
    {
      "en": "world-music",
      "cn": "世界音乐",
      "es": "rmusica mundial",
      "pt": "música mundial",
      "ko": "월드 뮤직",
      "ja": "ワールドミュージック",
      'zh-Hans': "世界音乐",
      'zh-Hant': "世界音樂",
      "de": "weltmusik",
      "fr": "musique du monde",
      "it": "Musica mondiale",
      "ru": "мировая музыка",
    },
    {
      "en": "indie",
      "cn": "独立音乐",
      "es": "independiente",
      "pt": "independente",
      "ko": "인디",
      "ja": "インディーズ",
      'zh-Hans': "独立音乐",
      'zh-Hant': "獨立音樂",
      "de": "indie",
      "fr": "indie",
      "it": "Musica indipendente",
      "ru": "Инди-музыка",
    },
    {
      "en": "classical",
      "cn": "古典",
      "es": "clásico",
      "pt": "clássico",
      "ko": "고전",
      "ja": "古典的な",
      'zh-Hans': "古典",
      'zh-Hant': "古典",
      "de": "Klassik",
      "fr": "classique",
      "it": "Classica",
      "ru": "классика",
    },
    {
      "en": "experimental",
      "cn": "实验音乐",
      "es": "experimental",
      "pt": "experimental",
      "ko": "실험적인",
      "ja": "実験的な",
      'zh-Hans': "实验音乐",
      'zh-Hant': "實驗音樂",
      "de": "experimentell",
      "fr": "expérimental",
      "it": "Musica sperimentale",
      "ru": "Экспериментальная музыка",
    },
    {
      "en": "children",
      "cn": "儿童音乐",
      "es": "niños",
      "pt": "crianças",
      "ko": "어린이들",
      "ja": "子供たち",
      'zh-Hans': "儿童音乐",
      'zh-Hant': "兒童音樂",
      "de": "Kinderlied",
      "fr": "musique pour enfants",
      "it": "Musica per bambini",
      "ru": "Детская музыка",
    },
    {
      "en": "dance",
      "cn": "舞曲",
      "es": "bailar",
      "pt": "dança",
      "ko": "춤",
      "ja": "ダンス",
      'zh-Hans': "舞曲",
      'zh-Hant': "舞曲",
      "de": "Dance",
      "fr": "danse",
      "it": "Musica da ballo",
      "ru": "Танцевальная музыка",
    },
    {
      "en": "80s synthpop",
      "cn": "80年代合成流行",
      "es": "pop sintético de los 80",
      "pt": "Sintetizador dos anos 80",
      "ko": "80년대 신스팝",
      "ja": "80 年代のシンセポップ",
      'zh-Hans': "80年代合成流行",
      'zh-Hant': "80年代合成流行",
      "de": "80er Synthpop",
      "fr": "synthpop des années 80",
      "it": "synthpop degli anni '80",
      "ru": "Синтвейв 80-х",
    },
    {
      "en": "89's old school rap",
      "cn": "89年代老派说唱",
      "es": "El rap de la vieja escuela del 89",
      "pt": "Rap da velha escola de 89",
      "ko": "89년대 올드스쿨 랩",
      "ja": "89 年代のオールドスクール ラップ",
      'zh-Hans': "89年代老派说唱",
      'zh-Hant': "89年代老派說唱",
      "de": "89er Old School Rap",
      "fr": "rap old school des années 89",
      "it": "Old school rap anni '89",
      "ru": "Олдскульный рэп 89-х",
    },
    {
      "en": "death metal",
      "cn": "死亡金属",
      "es": "metal de la muerte",
      "pt": "metal mortal",
      "ko": "데스 메탈",
      "ja": "デスメタル",
      'zh-Hans': "死亡金属",
      'zh-Hant': "死亡金屬",
      "de": "Death Metal",
      "fr": "death metal",
      "it": "death metal",
      "ru": "дэт-металл",
    },
    {
      "en": "lternative rock",
      "cn": "另类摇滚",
      "es": "rock alternativo",
      "pt": "rock alternativo",
      "ko": "얼터너티브 록",
      "ja": "オルタナティブ・ロック",
      'zh-Hans': "另类摇滚",
      'zh-Hant': "另類搖滾",
      "de": "alternativer Rock",
      "fr": "rock alternatif",
      "it": "rock alternativo",
      "ru": "альтернативный рок",
    },
    {
      "en": "j-pop",
      "cn": "日本流行",
      "es": "pop japonés",
      "pt": "J-pop",
      "ko": "J팝",
      "ja": "Jポップ",
      'zh-Hans': "日本流行",
      'zh-Hant': "日本流行",
      "de": "J-pop",
      "fr": "j-pop",
      "it": "j-pop",
      "ru": "J-pop (Японская поп-музыка)",
    },
    {
      "en": "EDM",
      "cn": "电子舞曲",
      "es": "electroerosión",
      "pt": "Música eletrônica",
      "ko": "EDM",
      "ja": "放電加工",
      'zh-Hans': "电子舞曲",
      'zh-Hant': "電子舞曲  ",
      "de": "EDM",
      "fr": "EDM(musique électronique de danse)",
      "it": "Electronic Dance Music (EDM)",
      "ru": "Электронная танцевальная музыка (EDM)",
    },
    {
      "en": "gritty melody",
      "cn": "粗犷旋律",
      "es": "melodía arenosa",
      "pt": "melodia corajosa",
      "ko": "거친 멜로디",
      "ja": "ザラザラしたメロディー",
      'zh-Hans': "粗犷旋律",
      'zh-Hant': "粗獷旋律",
      "de": "Grobe Melodie",
      "fr": "mélodie brute",
      "it": "Melodie grezze",
      "ru": "Грубые мелодии",
    },
    {
      "en": "k-pop",
      "cn": "韩流",
      "es": "k-pop",
      "pt": "K-pop",
      "ko": "케이팝",
      "ja": "Kポップ",
      'zh-Hans': "韩流",
      'zh-Hant': "韓流",
      "de": "k-pop",
      "fr": "k-pop",
      "it": "k-pop",
      "ru": "K-pop (Корейская поп-музыка)",
    },
    {
      "en": "ballad",
      "cn": "抒情歌",
      "es": "balada",
      "pt": "balada",
      "ko": "민요",
      "ja": "バラード",
      'zh-Hans': "抒情歌",
      'zh-Hant': "抒情歌",
      "de": "Ballade",
      "fr": "ballade",
      "it": "Canzoni d'amore",
      "ru": "Любовные песни",
    },
    {
      "en": "tip-hop",
      "cn": "催眠电子",
      "es": "tip-hop",
      "pt": "tip-hop",
      "ko": "팁홉",
      "ja": "チップホップ",
      'zh-Hans': "催眠电子",
      'zh-Hant': "催眠電子",
      "de": "tip-hop",
      "fr": "tip-hop",
      "it": "Jazz rap",
      "ru": "Джазовый хип-хоп",
    },
    {
      "en": "new wave",
      "cn": "新浪潮",
      "es": "nueva ola",
      "pt": "nova onda",
      "ko": "새 물결 운동",
      "ja": "新しい波",
      'zh-Hans': "新浪潮",
      'zh-Hant': "新浪潮",
      "de": "New Wave",
      "fr": "new wave",
      "it": "new wave",
      "ru": "Нью-вейв",
    },
    {
      "en": "orchestral",
      "cn": "管弦乐",
      "es": "orquestal",
      "pt": "orquestral",
      "ko": "오케스트라",
      "ja": "オーケストラの",
      'zh-Hans': "管弦乐",
      'zh-Hant': "管弦樂",
      "de": "Orchestral",
      "fr": "orchestral",
      "it": "Orchestra",
      "ru": "Оркестровая музыка",
    },
    {
      "en": "game music",
      "cn": "游戏音乐",
      "es": "musica de juego",
      "pt": "música do jogo",
      "ko": "게임 음악",
      "ja": "ゲームミュージック",
      'zh-Hans': "游戏音乐",
      'zh-Hant': "遊戲音樂",
      "de": "Spielemusik",
      "fr": "musique de jeu",
      "it": "Musica per videogiochi",
      "ru": "Музыка для игр",
    },
    {
      "en": "unique synths",
      "cn": "独特合成音",
      "es": "sintetizadores únicos",
      "pt": "sintetizadores exclusivos",
      "ko": "독특한 신디사이저",
      "ja": "ユニークなシンセ",
      'zh-Hans': "独特合成音",
      'zh-Hant': "獨特合成音",
      "de": "Unique Synths",
      "fr": "synthés uniques",
      "it": "Sintetizzatori unici",
      "ru": "Уникальные синтезаторы",
    },
    {
      "en": "vinyl samples",
      "cn": "黑胶采样",
      "es": "muestras de vinilo",
      "pt": "amostras de vinil",
      "ko": "비닐 샘플",
      "ja": "ビニールサンプル",
      'zh-Hans': "黑胶采样",
      'zh-Hant': "黑膠採樣",
      "de": "Vinyl-Samples",
      "fr": "échantillons vinyles",
      "it": "Campioni in vinile",
      "ru": "Винтажные сэмплы",
    },
    {
      "en": "instrumental loop",
      "cn": "乐器循环",
      "es": "Bucle instrumental",
      "pt": "Laço instrumental",
      "ko": "악기 루프",
      "ja": "インストゥルメンタルループ",
      'zh-Hans': "乐器循环",
      'zh-Hant': "樂器循環",
      "de": "Instrumental Loop",
      "fr": "boucle instrumentale",
      "it": "Loop strumentale",
      "ru": "инструментальный цикл",
    },
    {
      "en": "bass",
      "cn": "低音",
      "es": "bajo",
      "pt": "baixo",
      "ko": "베이스",
      "ja": "ベース",
      'zh-Hans': "低音",
      'zh-Hant': "低音",
      "de": "Bass",
      "fr": "basse",
      "it": "Bassi",
      "ru": "Басс"
    },
    {
      "en": "upbeat percussion",
      "cn": "轻快打击乐",
      "es": "percusión alegre",
      "pt": "percussão soulda",
      "ko": "경쾌한 타악기",
      "ja": "陽気なパーカッション",
      'zh-Hans': "轻快打击乐",
      'zh-Hant': "輕快打擊樂",
      "de": "Upbeat Percussion",
      "fr": "percussion dynamique",
      "it": "Percussioni vivaci",
      "ru": "Яркие ударные",
    },
    {
      "en": "guitar Riff",
      "cn": "吉他即兴段",
      "es": "riff de guitarra",
      "pt": "riff de guitarra",
      "ko": "기타 리프",
      "ja": "ギターリフ",
      'zh-Hans': "吉他即兴段",
      'zh-Hant': "吉他即興段",
      "de": "Gitarrenriff",
      "fr": "riff de guitare",
      "it": "riff di chitarra",
      "ru": "Гитарные риффы",
    },
    {
      "en": "atmospheric synths",
      "cn": "氛围合成音",
      "es": "sintetizadores atmosféricos",
      "pt": "sintetizadores atmosféricos",
      "ko": "대기 신디사이저",
      "ja": "雰囲気のあるシンセサイザー",
      'zh-Hans': "氛围合成音",
      'zh-Hant': "氛圍合成音",
      "de": "Atmosphärische Synths",
      "fr": "synthés atmosphériques",
      "it": "Sintetizzatori atmosferici",
      "ru": "Атмосферные синтезаторы",
    },
    {
      "en": "piano",
      "cn": "钢琴",
      "es": "piano",
      "pt": "piano",
      "ko": "피아노",
      "ja": "ピアノ",
      'zh-Hans': "钢琴",
      'zh-Hant': "鋼琴",
      "de": "Klavier",
      "fr": "piano",
      "it": "pianoforte",
      "ru": "Фортепиано",
    },
    {
      "en": "guitar",
      "cn": "吉他",
      "es": "guitarra",
      "pt": "guitarra",
      "ko": "기타",
      "ja": "ギター",
      'zh-Hans': "吉他",
      'zh-Hant': "吉他",
      "de": "Gitarre",
      "fr": "guitare",
      "it": "chitarra",
      "ru": "гитара",
    },
    {
      "en": "drums",
      "cn": "鼓",
      "es": "batería",
      "pt": "bateria",
      "ko": "드럼",
      "ja": "ドラム",
      'zh-Hans': "鼓",
      'zh-Hant': "鼓",
      "de": "Schlagzeug",
      "fr": "batterie",
      "it": "Batteria",
      "ru": "Барабаны",
    },
    {
      "en": "synth Pads",
      "cn": "合成音垫",
      "es": "Pads de sintetizador",
      "pt": "Pads de sintetizador",
      "ko": "신디사이저 패드",
      "ja": "シンセパッド",
      'zh-Hans': "合成音垫",
      'zh-Hant': "合成音墊",
      "de": "Synth-Pads",
      "fr": "pads de synthé",
      "it": "Tappeti sintetici",
      "ru": "Синтезаторные пэды",
    },
    {
      "en": "percussion",
      "cn": "打击乐器",
      "es": "percusión",
      "pt": "percussão",
      "ko": "충격",
      "ja": "パーカッション",
      'zh-Hans': "打击乐器",
      'zh-Hant': "打擊樂器",
      "de": "Percussion",
      "fr": "percussion",
      "it": "Percussioni",
      "ru": "Ударные",
    },
    {
      "en": "electric guitar",
      "cn": "电吉他",
      "es": "guitarra eléctrica",
      "pt": "guitarra elétrica",
      "ko": "일렉트릭 기타",
      "ja": "エレキギター",
      'zh-Hans': "电吉他",
      'zh-Hant': "電吉他",
      "de": "E-Gitarre",
      "fr": "guitare électrique",
      "it": "Chitarra elettrica",
      "ru": "Электрогитара",
    },
    {
      "en": "lo-fi",
      "cn": "低保真",
      "es": "baja fidelidad",
      "pt": "lo-fi",
      "ko": "로파이",
      "ja": "ローファイ",
      'zh-Hans': "低保真",
      'zh-Hant': "低保真",
      "de": "Lo-Fi",
      "fr": "lo-fi",
      "it": "lo-fi",
      "ru": "ло-фай",
    },
    {
      "en": "strings",
      "cn": "弦乐",
      "es": "instrumentos de cuerda",
      "pt": "cordas",
      "ko": "문자열",
      "ja": "文字列",
      'zh-Hans': "弦乐",
      'zh-Hant': "弦樂",
      "de": "Streicher",
      "fr": "cordes",
      "it": "Arch",
      "ru": "Струнные",
    },
    {
      "en": "softpercussion",
      "cn": "柔和打击乐",
      "es": "percusión suave",
      "pt": "percussão suave",
      "ko": "부드러운 타악기",
      "ja": "ソフトパーカッション",
      'zh-Hans': "柔和打击乐",
      'zh-Hant': "柔和打擊樂",
      "de": "Sanfte Percussion",
      "fr": "percussion douce",
      "it": "Percussioni leggere",
      "ru": "Легкие ударные",
    },
    {
      "en": "drum and Bass",
      "cn": "鼓与贝斯",
      "es": "tambor y bajo",
      "pt": "bateria e baixo",
      "ko": "드럼과 베이스",
      "ja": "ドラムとベース",
      'zh-Hans': "鼓与贝斯",
      'zh-Hant': "鼓與貝斯",
      "de": "Schlagzeug und Bass",
      "fr": "drum and bass",
      "it": "Batteria e basso",
      "ru": "Драм-энд-бэйс",
    },
    {
      "en": "midi",
      "cn": "音乐数字接口",
      "es": "midi",
      "pt": "midi",
      "ko": "미디",
      "ja": "ミディ",
      'zh-Hans': "音乐数字接口",
      'zh-Hant': "音樂數字接口",
      "de": "Midi",
      "fr": "midi",
      "it": "midi",
      "ru": "MIDI",
    },
    {
      "en": "dissonant",
      "cn": "不和谐音",
      "es": "disonante",
      "pt": "dissonante",
      "ko": "불협화음",
      "ja": "不協和音",
      'zh-Hans': "不和谐音",
      'zh-Hant': "不和諧音",
      "de": "dissonant",
      "fr": "dissonant",
      "it": "Dissonanza",
      "ru": "Диссонанс",
    },
    {
      "en": "female vocal",
      "cn": "女声",
      "es": "voz femenina",
      "pt": "vocal feminino",
      "ko": "여성 보컬",
      "ja": "女性ボーカル",
      'zh-Hans': "女声",
      'zh-Hant': "女聲",
      "de": "weiblicher Gesang",
      "fr": "voix féminine",
      "it": "Voce femminile",
      "ru": "Женский вокал",
    },
    {
      "en": "male vocal",
      "cn": "男声",
      "es": "voz masculina",
      "pt": "vocal masculino",
      "ko": "남성 보컬",
      "ja": "男性ボーカル",
      'zh-Hans': "男声",
      'zh-Hant': "男聲",
      "de": "Männlicher Gesang",
      "fr": "voix masculine",
      "it": "Voce maschile",
      "ru": "Мужской вокал",
    },
    {
      "en": "upbeat",
      "cn": "快节奏",
      "es": "optimista",
      "pt": "otimista",
      "ko": "상승 기조",
      "ja": "明るい",
      'zh-Hans': "快节奏",
      'zh-Hant': "快節奏",
      "de": "schnelles Tempo",
      "fr": "dynamique",
      "it": "Ritmo veloce",
      "ru": "Быстрый темп",
    },
    {
      "en": "driving rhythm",
      "cn": "强劲节奏",
      "es": "ritmo de conducción",
      "pt": "ritmo de condução",
      "ko": "운전 리듬",
      "ja": "運転リズム",
      'zh-Hans': "强劲节奏",
      'zh-Hant': "強勁節奏",
      "de": "treibender Rhythmus",
      "fr": "rythme entraînant",
      "it": "Ritmo incalzante",
      "ru": "Драйвовый ритм",
    },
    {
      "en": "rhythmic grooves",
      "cn": "节奏律动",
      "es": "ritmos rítmicos",
      "pt": "sulcos rítmicos",
      "ko": "리듬 그루브",
      "ja": "リズミカルなグルーヴ",
      'zh-Hans': "节奏律动",
      'zh-Hant': "節奏律動",
      "de": "rhythmische Grooves",
      "fr": "grooves rythmiques",
      "it": "Melodia ritmata",
      "ru": "Грувовая мелодия",
    },
    {
      "en": "party anthem",
      "cn": "派对神曲",
      "es": "himno del partido",
      "pt": "hino de festa",
      "ko": "파티 찬가",
      "ja": "党賛歌",
      'zh-Hans': "派对神曲",
      'zh-Hant': "派對神曲",
      "de": "Party-Hymne",
      "fr": "hymne de fête",
      "it": "Brano da festa",
      "ru": "Хит для вечеринок",
    },
    {
      "en": "chinoiserie",
      "cn": "国风",
      "es": "chinoiserie",
      "pt": "chinoiserie",
      "ko": "시누아즈리",
      "ja": "シノワズリ",
      'zh-Hans': "国风",
      'zh-Hant': "國風",
      "de": "Chinoiserie",
      "fr": "Chinoiserie",
      "it": "Cineseria",
      "ru": "Шинуазри",
    }
  ],
  map: {
    all: {
      "en": "all",
      "cn": "全部",
      "es": "total",
      "pt": "total",
      "ko": "모두",
      "ja": "すべて",
      'zh-Hans': "全部",
      'zh-Hant': "全部",
      "de": "alle",
      "fr": "tout",
      "it": "tutto",
      "ru": "все",
    },
    "pop": {
      "en": "pop",
      "cn": "流行",
      "es": "estallido",
      "pt": "pop",
      "ko": "팝",
      "ja": "ポップ",
      "zh-Hans": "流行",
      "zh-Hant": "流行",
      "de": "pop",
      "fr": "pop",
      "it": "pop",
      "ru": "Поп-музыка"
    },
    "r&b": {
      "en": "r&b",
      "cn": "节奏布鲁斯",
      "es": "R&B",
      "pt": "R&B",
      "ko": "알앤비",
      "ja": "R&B",
      "zh-Hans": "节奏布鲁斯",
      "zh-Hant": "節奏藍調",
      "de": "R&B",
      "fr": "R&B",
      "it": "R&B",
      "ru": "R&B"
    },
    "rock": {
      "en": "rock",
      "cn": "摇滚",
      "es": "roca",
      "pt": "pedra",
      "ko": "바위",
      "ja": "ロック",
      "zh-Hans": "摇滚",
      "zh-Hant": "搖滾",
      "de": "rock",
      "fr": "rock",
      "it": "roccia",
      "ru": "рок"
    },
    "disco": {
      "en": "disco",
      "cn": "迪斯科",
      "es": "disco",
      "pt": "discoteca",
      "ko": "디스코",
      "ja": "ディスコ",
      "zh-Hans": "迪斯科",
      "zh-Hant": "迪斯科",
      "de": "disco",
      "fr": "disco",
      "it": "disco",
      "ru": "диско"
    },
    "electronic": {
      "en": "electronic",
      "cn": "电子",
      "es": "electrónico",
      "pt": "eletrônico",
      "ko": "전자",
      "ja": "電子",
      "zh-Hans": "电子",
      "zh-Hant": "電子",
      "de": "Electro",
      "fr": "électronique",
      "it": "Elettronica",
      "ru": "Электроника"
    },
    "folk": {
      "en": "folk",
      "cn": "民谣",
      "es": "gente",
      "pt": "povo",
      "ko": "사람들",
      "ja": "フォーク",
      "zh-Hans": "民谣",
      "zh-Hant": "民謠",
      "de": "Volkslied",
      "fr": "folk",
      "it": "folk",
      "ru": "Фолк"
    },
    "funk": {
      "en": "funk",
      "cn": "放克",
      "es": "canguelo",
      "pt": "funk",
      "ko": "펑키 재즈",
      "ja": "ファンク",
      "zh-Hans": "放克",
      "zh-Hant": "放克",
      "de": "funk",
      "fr": "funk",
      "it": "funk",
      "ru": "фанк"
    },
    "country": {
      "en": "country",
      "cn": "乡村",
      "es": "país",
      "pt": "país",
      "ko": "국가",
      "ja": "国",
      "zh-Hans": "乡村",
      "zh-Hant": "鄉村",
      "de": "country",
      "fr": "country",
      "it": "country",
      "ru": "Кантри"
    },
    "hip-hop": {
      "en": "hip-hop",
      "cn": "嘻哈",
      "es": "hip-hop",
      "pt": "hip-hop",
      "ko": "힙합",
      "ja": "ヒップホップ",
      "zh-Hans": "嘻哈",
      "zh-Hant": "嘻哈",
      "de": "hip-hop",
      "fr": "hip-hop",
      "it": "hip-hop",
      "ru": "хип-хоп"
    },
    "jazz": {
      "en": "jazz",
      "cn": "爵士",
      "es": "jazz",
      "pt": "jazz",
      "ko": "재즈",
      "ja": "ジャズ",
      "zh-Hans": "爵士",
      "zh-Hant": "爵士",
      "de": "jazz",
      "fr": "jazz",
      "it": "jazz",
      "ru": "джаз"
    },
    "latin": {
      "en": "latin",
      "cn": "拉丁",
      "es": "latín",
      "pt": "latim",
      "ko": "라틴어",
      "ja": "ラテン",
      "zh-Hans": "拉丁",
      "zh-Hant": "拉丁",
      "de": "Latino",
      "fr": "latino",
      "it": "latina",
      "ru": "Латино"
    },
    "metal": {
      "en": "metal",
      "cn": "金属",
      "es": "metal",
      "pt": "metal",
      "ko": "금속",
      "ja": "金属",
      "zh-Hans": "金属",
      "zh-Hant": "金屬",
      "de": "metal",
      "fr": "métal",
      "it": "metal",
      "ru": "Метал"
    },
    "blues": {
      "en": "blues",
      "cn": "布鲁斯",
      "es": "blues",
      "pt": "blues",
      "ko": "블루스",
      "ja": "ブルース",
      "zh-Hans": "布鲁斯",
      "zh-Hant": "布鲁斯",
      "de": "blues",
      "fr": "blues",
      "it": "blues",
      "ru": "Блюз"
    },
    "punk": {
      "en": "punk",
      "cn": "朋克",
      "es": "punk",
      "pt": "punk",
      "ko": "펑크",
      "ja": "パンク",
      "zh-Hans": "朋克",
      "zh-Hant": "龐克",
      "de": "punk",
      "fr": "punk",
      "it": "punk",
      "ru": "Панк"
    },
    "reggae": {
      "en": "reggae",
      "cn": "雷鬼",
      "es": "reggae",
      "pt": "reggae",
      "ko": "레게",
      "ja": "レゲエ",
      "zh-Hans": "雷鬼",
      "zh-Hant": "雷鬼",
      "de": "reggae",
      "fr": "reggae",
      "it": "reggae",
      "ru": "регги"
    },
    "soul": {
      "en": "soul",
      "cn": "灵魂",
      "es": "alma",
      "pt": "alma",
      "ko": "영혼",
      "ja": "魂",
      "zh-Hans": "灵魂",
      "zh-Hant": "靈魂",
      "de": "soul",
      "fr": "soul",
      "it": "soul",
      "ru": "Соул"
    },
    "indian": {
      "en": "indian",
      "cn": "印度风",
      "es": "indio",
      "pt": "indiano",
      "ko": "옥수수",
      "ja": "インド人",
      "zh-Hans": "印度风",
      "zh-Hant": "印度風",
      "de": "indisch",
      "fr": "indien",
      "it": "Musica indiana",
      "ru": "Индийская музыка"
    },
    "afrobeat": {
      "en": "afrobeat",
      "cn": "非洲节拍",
      "es": "afrobeat",
      "pt": "afrobeat",
      "ko": "아프로비트",
      "ja": "アフロビート",
      "zh-Hans": "非洲节拍",
      "zh-Hant": "非洲節拍",
      "de": "afrobeat",
      "fr": "afrobeat",
      "it": "Ritmi africani",
      "ru": "Африканские ритмы"
    },
    "world-music": {
      "en": "world-music",
      "cn": "世界音乐",
      "es": "rmusica mundial",
      "pt": "música mundial",
      "ko": "월드 뮤직",
      "ja": "ワールドミュージック",
      "zh-Hans": "世界音乐",
      "zh-Hant": "世界音樂",
      "de": "weltmusik",
      "fr": "musique du monde",
      "it": "Musica mondiale",
      "ru": "мировая музыка"
    },
    "indie": {
      "en": "indie",
      "cn": "独立音乐",
      "es": "independiente",
      "pt": "independente",
      "ko": "인디",
      "ja": "インディーズ",
      "zh-Hans": "独立音乐",
      "zh-Hant": "獨立音樂",
      "de": "indie",
      "fr": "indie",
      "it": "Musica indipendente",
      "ru": "Инди-музыка"
    },
    "classical": {
      "en": "classical",
      "cn": "古典",
      "es": "clásico",
      "pt": "clássico",
      "ko": "고전",
      "ja": "古典的な",
      "zh-Hans": "古典",
      "zh-Hant": "古典",
      "de": "Klassik",
      "fr": "classique",
      "it": "Classica",
      "ru": "классика"
    },
    "experimental": {
      "en": "experimental",
      "cn": "实验音乐",
      "es": "experimental",
      "pt": "experimental",
      "ko": "실험적인",
      "ja": "実験的な",
      "zh-Hans": "实验音乐",
      "zh-Hant": "實驗音樂",
      "de": "experimentell",
      "fr": "expérimental",
      "it": "Musica sperimentale",
      "ru": "Экспериментальная музыка"
    },
    "children": {
      "en": "children",
      "cn": "儿童音乐",
      "es": "niños",
      "pt": "crianças",
      "ko": "어린이들",
      "ja": "子供たち",
      "zh-Hans": "儿童音乐",
      "zh-Hant": "兒童音樂",
      "de": "Kinderlied",
      "fr": "musique pour enfants",
      "it": "Musica per bambini",
      "ru": "Детская музыка"
    },
    "dance": {
      "en": "dance",
      "cn": "舞曲",
      "es": "bailar",
      "pt": "dança",
      "ko": "춤",
      "ja": "ダンス",
      "zh-Hans": "舞曲",
      "zh-Hant": "舞曲",
      "de": "Dance",
      "fr": "danse",
      "it": "Musica da ballo",
      "ru": "Танцевальная музыка"
    },
    "80s synthpop": {
      "en": "80s synthpop",
      "cn": "80年代合成流行",
      "es": "pop sintético de los 80",
      "pt": "Sintetizador dos anos 80",
      "ko": "80년대 신스팝",
      "ja": "80 年代のシンセポップ",
      "zh-Hans": "80年代合成流行",
      "zh-Hant": "80年代合成流行",
      "de": "80er Synthpop",
      "fr": "synthpop des années 80",
      "it": "synthpop degli anni '80",
      "ru": "Синтвейв 80-х"
    },
    "89's old school rap": {
      "en": "89's old school rap",
      "cn": "89年代老派说唱",
      "es": "El rap de la vieja escuela del 89",
      "pt": "Rap da velha escola de 89",
      "ko": "89년대 올드스쿨 랩",
      "ja": "89 年代のオールドスクール ラップ",
      "zh-Hans": "89年代老派说唱",
      "zh-Hant": "89年代老派說唱",
      "de": "89er Old School Rap",
      "fr": "rap old school des années 89",
      "it": "Old school rap anni '89",
      "ru": "Олдскульный рэп 89-х"
    },
    "death metal": {
      "en": "death metal",
      "cn": "死亡金属",
      "es": "metal de la muerte",
      "pt": "metal mortal",
      "ko": "데스 메탈",
      "ja": "デスメタル",
      "zh-Hans": "死亡金属",
      "zh-Hant": "死亡金屬",
      "de": "Death Metal",
      "fr": "death metal",
      "it": "death metal",
      "ru": "дэт-металл"
    },
    "lternative rock": {
      "en": "lternative rock",
      "cn": "另类摇滚",
      "es": "rock alternativo",
      "pt": "rock alternativo",
      "ko": "얼터너티브 록",
      "ja": "オルタナティブ・ロック",
      "zh-Hans": "另类摇滚",
      "zh-Hant": "另類搖滾",
      "de": "alternativer Rock",
      "fr": "rock alternatif",
      "it": "rock alternativo",
      "ru": "альтернативный рок"
    },
    "j-pop": {
      "en": "j-pop",
      "cn": "日本流行",
      "es": "pop japonés",
      "pt": "J-pop",
      "ko": "J팝",
      "ja": "Jポップ",
      "zh-Hans": "日本流行",
      "zh-Hant": "日本流行",
      "de": "J-pop",
      "fr": "j-pop",
      "it": "j-pop",
      "ru": "J-pop (Японская поп-музыка)"
    },
    "EDM": {
      "en": "EDM",
      "cn": "电子舞曲",
      "es": "electroerosión",
      "pt": "Música eletrônica",
      "ko": "EDM",
      "ja": "放電加工",
      "zh-Hans": "电子舞曲",
      "zh-Hant": "電子舞曲  ",
      "de": "EDM",
      "fr": "EDM(musique électronique de danse)",
      "it": "Electronic Dance Music (EDM)",
      "ru": "Электронная танцевальная музыка (EDM)"
    },
    "gritty melody": {
      "en": "gritty melody",
      "cn": "粗犷旋律",
      "es": "melodía arenosa",
      "pt": "melodia corajosa",
      "ko": "거친 멜로디",
      "ja": "ザラザラしたメロディー",
      "zh-Hans": "粗犷旋律",
      "zh-Hant": "粗獷旋律",
      "de": "Grobe Melodie",
      "fr": "mélodie brute",
      "it": "Melodie grezze",
      "ru": "Грубые мелодии"
    },
    "k-pop": {
      "en": "k-pop",
      "cn": "韩流",
      "es": "k-pop",
      "pt": "K-pop",
      "ko": "케이팝",
      "ja": "Kポップ",
      "zh-Hans": "韩流",
      "zh-Hant": "韓流",
      "de": "k-pop",
      "fr": "k-pop",
      "it": "k-pop",
      "ru": "K-pop (Корейская поп-музыка)"
    },
    "ballad": {
      "en": "ballad",
      "cn": "抒情歌",
      "es": "balada",
      "pt": "balada",
      "ko": "민요",
      "ja": "バラード",
      "zh-Hans": "抒情歌",
      "zh-Hant": "抒情歌",
      "de": "Ballade",
      "fr": "ballade",
      "it": "Canzoni d'amore",
      "ru": "Любовные песни"
    },
    "tip-hop": {
      "en": "tip-hop",
      "cn": "催眠电子",
      "es": "tip-hop",
      "pt": "tip-hop",
      "ko": "팁홉",
      "ja": "チップホップ",
      "zh-Hans": "催眠电子",
      "zh-Hant": "催眠電子",
      "de": "tip-hop",
      "fr": "tip-hop",
      "it": "Jazz rap",
      "ru": "Джазовый хип-хоп"
    },
    "new wave": {
      "en": "new wave",
      "cn": "新浪潮",
      "es": "nueva ola",
      "pt": "nova onda",
      "ko": "새 물결 운동",
      "ja": "新しい波",
      "zh-Hans": "新浪潮",
      "zh-Hant": "新浪潮",
      "de": "New Wave",
      "fr": "new wave",
      "it": "new wave",
      "ru": "Нью-вейв"
    },
    "orchestral": {
      "en": "orchestral",
      "cn": "管弦乐",
      "es": "orquestal",
      "pt": "orquestral",
      "ko": "오케스트라",
      "ja": "オーケストラの",
      "zh-Hans": "管弦乐",
      "zh-Hant": "管弦樂",
      "de": "Orchestral",
      "fr": "orchestral",
      "it": "Orchestra",
      "ru": "Оркестровая музыка"
    },
    "game music": {
      "en": "game music",
      "cn": "游戏音乐",
      "es": "musica de juego",
      "pt": "música do jogo",
      "ko": "게임 음악",
      "ja": "ゲームミュージック",
      "zh-Hans": "游戏音乐",
      "zh-Hant": "遊戲音樂",
      "de": "Spielemusik",
      "fr": "musique de jeu",
      "it": "Musica per videogiochi",
      "ru": "Музыка для игр"
    },
    "unique synths": {
      "en": "unique synths",
      "cn": "独特合成音",
      "es": "sintetizadores únicos",
      "pt": "sintetizadores exclusivos",
      "ko": "독특한 신디사이저",
      "ja": "ユニークなシンセ",
      "zh-Hans": "独特合成音",
      "zh-Hant": "獨特合成音",
      "de": "Unique Synths",
      "fr": "synthés uniques",
      "it": "Sintetizzatori unici",
      "ru": "Уникальные синтезаторы"
    },
    "vinyl samples": {
      "en": "vinyl samples",
      "cn": "黑胶采样",
      "es": "muestras de vinilo",
      "pt": "amostras de vinil",
      "ko": "비닐 샘플",
      "ja": "ビニールサンプル",
      "zh-Hans": "黑胶采样",
      "zh-Hant": "黑膠採樣",
      "de": "Vinyl-Samples",
      "fr": "échantillons vinyles",
      "it": "Campioni in vinile",
      "ru": "Винтажные сэмплы"
    },
    "instrumental loop": {
      "en": "instrumental loop",
      "cn": "乐器循环",
      "es": "Bucle instrumental",
      "pt": "Laço instrumental",
      "ko": "악기 루프",
      "ja": "インストゥルメンタルループ",
      "zh-Hans": "乐器循环",
      "zh-Hant": "樂器循環",
      "de": "Instrumental Loop",
      "fr": "boucle instrumentale",
      "it": "Loop strumentale",
      "ru": "инструментальный цикл"
    },
    "bass": {
      "en": "bass",
      "cn": "低音",
      "es": "bajo",
      "pt": "baixo",
      "ko": "베이스",
      "ja": "ベース",
      "zh-Hans": "低音",
      "zh-Hant": "低音",
      "de": "Bass",
      "fr": "basse",
      "it": "Bassi",
      "ru": "Басс"
    },
    "upbeat percussion": {
      "en": "upbeat percussion",
      "cn": "轻快打击乐",
      "es": "percusión alegre",
      "pt": "percussão soulda",
      "ko": "경쾌한 타악기",
      "ja": "陽気なパーカッション",
      "zh-Hans": "轻快打击乐",
      "zh-Hant": "輕快打擊樂",
      "de": "Upbeat Percussion",
      "fr": "percussion dynamique",
      "it": "Percussioni vivaci",
      "ru": "Яркие ударные"
    },
    "guitar Riff": {
      "en": "guitar Riff",
      "cn": "吉他即兴段",
      "es": "riff de guitarra",
      "pt": "riff de guitarra",
      "ko": "기타 리프",
      "ja": "ギターリフ",
      "zh-Hans": "吉他即兴段",
      "zh-Hant": "吉他即興段",
      "de": "Gitarrenriff",
      "fr": "riff de guitare",
      "it": "riff di chitarra",
      "ru": "Гитарные риффы"
    },
    "atmospheric synths": {
      "en": "atmospheric synths",
      "cn": "氛围合成音",
      "es": "sintetizadores atmosféricos",
      "pt": "sintetizadores atmosféricos",
      "ko": "대기 신디사이저",
      "ja": "雰囲気のあるシンセサイザー",
      "zh-Hans": "氛围合成音",
      "zh-Hant": "氛圍合成音",
      "de": "Atmosphärische Synths",
      "fr": "synthés atmosphériques",
      "it": "Sintetizzatori atmosferici",
      "ru": "Атмосферные синтезаторы"
    },
    "piano": {
      "en": "piano",
      "cn": "钢琴",
      "es": "piano",
      "pt": "piano",
      "ko": "피아노",
      "ja": "ピアノ",
      "zh-Hans": "钢琴",
      "zh-Hant": "鋼琴",
      "de": "Klavier",
      "fr": "piano",
      "it": "pianoforte",
      "ru": "Фортепиано"
    },
    "guitar": {
      "en": "guitar",
      "cn": "吉他",
      "es": "guitarra",
      "pt": "guitarra",
      "ko": "기타",
      "ja": "ギター",
      "zh-Hans": "吉他",
      "zh-Hant": "吉他",
      "de": "Gitarre",
      "fr": "guitare",
      "it": "chitarra",
      "ru": "гитара"
    },
    "drums": {
      "en": "drums",
      "cn": "鼓",
      "es": "batería",
      "pt": "bateria",
      "ko": "드럼",
      "ja": "ドラム",
      "zh-Hans": "鼓",
      "zh-Hant": "鼓",
      "de": "Schlagzeug",
      "fr": "batterie",
      "it": "Batteria",
      "ru": "Барабаны"
    },
    "synth Pads": {
      "en": "synth Pads",
      "cn": "合成音垫",
      "es": "Pads de sintetizador",
      "pt": "Pads de sintetizador",
      "ko": "신디사이저 패드",
      "ja": "シンセパッド",
      "zh-Hans": "合成音垫",
      "zh-Hant": "合成音墊",
      "de": "Synth-Pads",
      "fr": "pads de synthé",
      "it": "Tappeti sintetici",
      "ru": "Синтезаторные пэды"
    },
    "percussion": {
      "en": "percussion",
      "cn": "打击乐器",
      "es": "percusión",
      "pt": "percussão",
      "ko": "충격",
      "ja": "パーカッション",
      "zh-Hans": "打击乐器",
      "zh-Hant": "打擊樂器",
      "de": "Percussion",
      "fr": "percussion",
      "it": "Percussioni",
      "ru": "Ударные"
    },
    "electric guitar": {
      "en": "electric guitar",
      "cn": "电吉他",
      "es": "guitarra eléctrica",
      "pt": "guitarra elétrica",
      "ko": "일렉트릭 기타",
      "ja": "エレキギター",
      "zh-Hans": "电吉他",
      "zh-Hant": "電吉他",
      "de": "E-Gitarre",
      "fr": "guitare électrique",
      "it": "Chitarra elettrica",
      "ru": "Электрогитара"
    },
    "lo-fi": {
      "en": "lo-fi",
      "cn": "低保真",
      "es": "baja fidelidad",
      "pt": "lo-fi",
      "ko": "로파이",
      "ja": "ローファイ",
      "zh-Hans": "低保真",
      "zh-Hant": "低保真",
      "de": "Lo-Fi",
      "fr": "lo-fi",
      "it": "lo-fi",
      "ru": "ло-фай"
    },
    "strings": {
      "en": "strings",
      "cn": "弦乐",
      "es": "instrumentos de cuerda",
      "pt": "cordas",
      "ko": "문자열",
      "ja": "文字列",
      "zh-Hans": "弦乐",
      "zh-Hant": "弦樂",
      "de": "Streicher",
      "fr": "cordes",
      "it": "Arch",
      "ru": "Струнные"
    },
    "softpercussion": {
      "en": "softpercussion",
      "cn": "柔和打击乐",
      "es": "percusión suave",
      "pt": "percussão suave",
      "ko": "부드러운 타악기",
      "ja": "ソフトパーカッション",
      "zh-Hans": "柔和打击乐",
      "zh-Hant": "柔和打擊樂",
      "de": "Sanfte Percussion",
      "fr": "percussion douce",
      "it": "Percussioni leggere",
      "ru": "Легкие ударные"
    },
    "drum and Bass": {
      "en": "drum and Bass",
      "cn": "鼓与贝斯",
      "es": "tambor y bajo",
      "pt": "bateria e baixo",
      "ko": "드럼과 베이스",
      "ja": "ドラムとベース",
      "zh-Hans": "鼓与贝斯",
      "zh-Hant": "鼓與貝斯",
      "de": "Schlagzeug und Bass",
      "fr": "drum and bass",
      "it": "Batteria e basso",
      "ru": "Драм-энд-бэйс"
    },
    "midi": {
      "en": "midi",
      "cn": "音乐数字接口",
      "es": "midi",
      "pt": "midi",
      "ko": "미디",
      "ja": "ミディ",
      "zh-Hans": "音乐数字接口",
      "zh-Hant": "音樂數字接口",
      "de": "Midi",
      "fr": "midi",
      "it": "midi",
      "ru": "MIDI"
    },
    "dissonant": {
      "en": "dissonant",
      "cn": "不和谐音",
      "es": "disonante",
      "pt": "dissonante",
      "ko": "불협화음",
      "ja": "不協和音",
      "zh-Hans": "不和谐音",
      "zh-Hant": "不和諧音",
      "de": "dissonant",
      "fr": "dissonant",
      "it": "Dissonanza",
      "ru": "Диссонанс"
    },
    "female vocal": {
      "en": "female vocal",
      "cn": "女声",
      "es": "voz femenina",
      "pt": "vocal feminino",
      "ko": "여성 보컬",
      "ja": "女性ボーカル",
      "zh-Hans": "女声",
      "zh-Hant": "女聲",
      "de": "weiblicher Gesang",
      "fr": "voix féminine",
      "it": "Voce femminile",
      "ru": "Женский вокал"
    },
    "male vocal": {
      "en": "male vocal",
      "cn": "男声",
      "es": "voz masculina",
      "pt": "vocal masculino",
      "ko": "남성 보컬",
      "ja": "男性ボーカル",
      "zh-Hans": "男声",
      "zh-Hant": "男聲",
      "de": "Männlicher Gesang",
      "fr": "voix masculine",
      "it": "Voce maschile",
      "ru": "Мужской вокал"
    },
    "upbeat": {
      "en": "upbeat",
      "cn": "快节奏",
      "es": "optimista",
      "pt": "otimista",
      "ko": "상승 기조",
      "ja": "明るい",
      "zh-Hans": "快节奏",
      "zh-Hant": "快節奏",
      "de": "schnelles Tempo",
      "fr": "dynamique",
      "it": "Ritmo veloce",
      "ru": "Быстрый темп"
    },
    "driving rhythm": {
      "en": "driving rhythm",
      "cn": "强劲节奏",
      "es": "ritmo de conducción",
      "pt": "ritmo de condução",
      "ko": "운전 리듬",
      "ja": "運転リズム",
      "zh-Hans": "强劲节奏",
      "zh-Hant": "強勁節奏",
      "de": "treibender Rhythmus",
      "fr": "rythme entraînant",
      "it": "Ritmo incalzante",
      "ru": "Драйвовый ритм"
    },
    "rhythmic grooves": {
      "en": "rhythmic grooves",
      "cn": "节奏律动",
      "es": "ritmos rítmicos",
      "pt": "sulcos rítmicos",
      "ko": "리듬 그루브",
      "ja": "リズミカルなグルーヴ",
      "zh-Hans": "节奏律动",
      "zh-Hant": "節奏律動",
      "de": "rhythmische Grooves",
      "fr": "grooves rythmiques",
      "it": "Melodia ritmata",
      "ru": "Грувовая мелодия"
    },
    "party anthem": {
      "en": "party anthem",
      "cn": "派对神曲",
      "es": "himno del partido",
      "pt": "hino de festa",
      "ko": "파티 찬가",
      "ja": "党賛歌",
      "zh-Hans": "派对神曲",
      "zh-Hant": "派對神曲",
      "de": "Party-Hymne",
      "fr": "hymne de fête",
      "it": "Brano da festa",
      "ru": "Хит для вечеринок"
    },

    "chinoiserie": {
      "en": "chinoiserie",
      "cn": "国风",
      "es": "chinoiserie",
      "pt": "chinoiserie",
      "ko": "시누아즈리",
      "ja": "シノワズリ",
      'zh-Hans': "国风",
      'zh-Hant': "國風",
      "de": "Chinoiserie",
      "fr": "Chinoiserie",
      "it": "Cineseria",
      "ru": "Шинуазри",
    }

  }
};
// 生成-曲风-中文
export const StyleLabelDataCN = {
  list: [
    {
      "en": "流行",
      "cn": "流行",
    },
    {
      "en": "电子",
      "cn": "电子",
    },
    {
      "en": "民谣",
      "cn": "民谣",
    },
    {
      "en": "说唱",
      "cn": "说唱",
    },
    {
      "en": "摇滚",
      "cn": "摇滚",
    },
    // {
    //   "en": "爵士",
    //   "cn": "爵士",
    // },
    // {
    //   "en": "古典",
    //   "cn": "古典",
    // },
    {
      "en": "R&B/Soul",
      "cn": "R&B/Soul",
    },
    {
      "en": "古风",
      "cn": "古风",
    },
    // {
    //   "en": "布鲁斯",
    //   "cn": "布鲁斯",
    // },
    // {
    //   "en": "乡村",
    //   "cn": "乡村",
    // },
    // {
    //   "en": "世界音乐",
    //   "cn": "世界音乐",
    // },
    // {
    //   "en": "放克",
    //   "cn": "放克",
    // },
    // {
    //   "en": "中国民族",
    //   "cn": "中国民族",
    // },
    // {
    //   "en": "ACG",
    //   "cn": "ACG",
    // },
    // {
    //   "en": "City Pop",
    //   "cn": "City Pop",
    // },
    // {
    //   "en": "DJ 舞曲",
    //   "cn": "DJ 舞曲",
    // },
  ],
  map: {
    流行: {
      "en": "流行",
      "cn": "流行",
    },
    电子: {
      "en": "电子",
      "cn": "电子",
    },
    民谣: {
      "en": "民谣",
      "cn": "民谣",
    },
    说唱: {
      "en": "说唱",
      "cn": "说唱",
    },
    摇滚: {
      "en": "摇滚",
      "cn": "摇滚",
    },
    // 爵士: {
    //   "en": "爵士",
    //   "cn": "爵士",
    // },
    // 古典: {
    //   "en": "古典",
    //   "cn": "古典",
    // },
    "R&B/Soul": {
      "en": "R&B/Soul",
      "cn": "R&B/Soul",
    },
    古风: {
      "en": "古风",
      "cn": "古风",
    },
    // 布鲁斯: {
    //   "en": "布鲁斯",
    //   "cn": "布鲁斯",
    // },
    // 乡村: {
    //   "en": "乡村",
    //   "cn": "乡村",
    // },
    // 世界音乐: {
    //   "en": "世界音乐",
    //   "cn": "世界音乐",
    // },
    // 放克: {
    //   "en": "放克",
    //   "cn": "放克",
    // },
    // 中国民族: {
    //   "en": "中国民族",
    //   "cn": "中国民族",
    // },
    // ACG: {
    //   "en": "ACG",
    //   "cn": "ACG",
    // },
    // "City Pop": {
    //   "en": "City Pop",
    //   "cn": "City Pop",
    // },
    // "DJ 舞曲": {
    //   "en": "DJ 舞曲",
    //   "cn": "DJ 舞曲",
    // },
  },
};
// 生成-曲风
export const StyleLabelData = StyleLabelDataEN
// 生成-情绪-英文
export const EmotionalLabelDataEN = {
  list: [
    {
      "en": "relaxed",
      "cn": "放松",
      "es": "relajado",
      "pt": "relaxado",
      "ko": "편안한",
      "ja": "リラックスした",
      'zh-Hans': "放松",
      'zh-Hant': "放鬆",
      "de": "entspannt",
      "fr": "détendu",
      "it": "rilassato",
      "ru": "расслабленный",
    },
    {
      "en": "angry",
      "cn": "愤怒",
      "es": "enojado",
      "pt": "nervoso",
      "ko": "화난",
      "ja": "怒り",
      'zh-Hans': "愤怒",
      'zh-Hant': "憤怒",
      "de": "wütend",
      "fr": "en colère",
      "it": "arrabbiato",
      "ru": "злой",
    },
    {
      "en": "happy",
      "cn": "开心",
      "es": "feliz",
      "pt": "feliz",
      "ko": "행복하다",
      "ja": "ハッピー",
      'zh-Hans': "开心",
      'zh-Hant': "開心",
      "de": "glücklich",
      "fr": "heureux",
      "it": "Felice",
      "ru": "счастливый",
    },
    {
      "en": "energetic",
      "cn": "充满活力",
      "es": "energético",
      "pt": "enérgico",
      "ko": "정력적인",
      "ja": "エネルギッシュな",
      'zh-Hans': "充满活力",
      'zh-Hant': "充滿活力",
      "de": "energiegeladen",
      "fr": "énergique",
      "it": "Energetico",
      "ru": "Энергичная",
    },
    {
      "en": "sad",
      "cn": "悲伤",
      "es": "triste",
      "pt": "triste",
      "ko": "슬픈",
      "ja": "悲しい",
      'zh-Hans': "悲伤",
      'zh-Hant': "悲傷",
      "de": "traurig",
      "fr": "triste",
      "it": "triste",
      "ru": "грустный",
    },
    {
      "en": "calm",
      "cn": "平静",
      "es": "calma",
      "pt": "calma",
      "ko": "침착한",
      "ja": "落ち着いた",
      'zh-Hans': "平静",
      'zh-Hant': "平靜",
      "de": "ruhig",
      "fr": "calme",
      "it": "calmo",
      "ru": "спокойный",
    },
    {
      "en": "inspired",
      "cn": "激发灵感",
      "es": "inspirado",
      "pt": "inspirado",
      "ko": "탁월한",
      "ja": "インスパイヤされた",
      'zh-Hans': "激发灵感",
      'zh-Hant': "激發靈感",
      "de": "inspiriert",
      "fr": "inspiré",
      "it": "ispirato",
      "ru": "Вдохновляющая",
    },
    {
      "en": "mysterious",
      "cn": "神秘",
      "es": "misterioso",
      "pt": "misterioso",
      "ko": "신비한",
      "ja": "神秘的な",
      'zh-Hans': "神秘",
      'zh-Hant': "神秘",
      "de": "geheimnisvoll",
      "fr": "mystérieux",
      "it": "misterioso",
      "ru": "Загадочная",
    },
    {
      "en": "majestic",
      "cn": "宏伟",
      "es": "majestuoso",
      "pt": "majestoso",
      "ko": "위엄 있는",
      "ja": "雄大な",
      'zh-Hans': "宏伟",
      'zh-Hant': "宏偉",
      "de": "majestätisch",
      "fr": "magnifique",
      "it": "magnifico",
      "ru": "Величественная",
    },
    {
      "en": "quirky",
      "cn": "古怪",
      "es": "peculiar",
      "pt": "peculiar",
      "ko": "기발한",
      "ja": "風変わりな",
      'zh-Hans': "古怪",
      'zh-Hant': "古怪",
      "de": "grotesk",
      "fr": "bizarre",
      "it": "Bizzarro",
      "ru": "Причудливая",
    },
    {
      "en": "restless",
      "cn": "焦躁",
      "es": "inquieto",
      "pt": "agitado",
      "ko": "불안한",
      "ja": "落ち着きのない",
      'zh-Hans': "焦躁",
      'zh-Hant': "焦躁",
      "de": "unruhig",
      "fr": "agité",
      "it": "Inquieto",
      "ru": "Тревожная",
    },
    {
      "en": "romantic",
      "cn": "浪漫",
      "es": "romantico",
      "pt": "romântico",
      "ko": "낭만적인",
      "ja": "ロマンチックな",
      'zh-Hans': "浪漫",
      'zh-Hant': "浪漫",
      "de": "romantisch",
      "fr": "romantique",
      "it": "romantico",
      "ru": "романтичный",
    },
    {
      "en": "dark",
      "cn": "黑暗",
      "es": "oscuro",
      "pt": "escuro",
      "ko": "어두운",
      "ja": "暗い",
      'zh-Hans': "黑暗",
      'zh-Hant': "黑暗",
      "de": "dunkel",
      "fr": "sombre",
      "it": "Oscuro",
      "ru": "Тёмная",
    },
    {
      "en": "warm",
      "cn": "温暖",
      "es": "cálido",
      "pt": "esquentar",
      "ko": "따뜻한",
      "ja": "暖かい",
      'zh-Hans': "温暖",
      'zh-Hant': "溫暖",
      "de": "warm",
      "fr": "chaleureux",
      "it": "caldo",
      "ru": "Тёплая",
    },
    {
      "en": "passionate",
      "cn": "热情",
      "es": "apasionado",
      "pt": "apaixonado",
      "ko": "열렬한",
      "ja": "情熱的な",
      'zh-Hans': "热情",
      'zh-Hant': "熱情",
      "de": "leidenschaftlich",
      "fr": "passionné",
      "it": "Passionale",
      "ru": "Страстная",
    },
    {
      "en": "joyful",
      "cn": "欢乐",
      "es": "alegre",
      "pt": "alegre",
      "ko": "즐거운",
      "ja": "楽しい",
      'zh-Hans': "欢乐",
      'zh-Hant': "歡樂",
      "de": "fröhlich",
      "fr": "joyeux",
      "it": "Felice",
      "ru": "Радостная",
    },
    {
      "en": "emotional",
      "cn": "情感丰富",
      "es": "emocional",
      "pt": "emocional",
      "ko": "감정적인",
      "ja": "感情的",
      'zh-Hans': "情感丰富",
      'zh-Hant': "情感豐富",
      "de": "sentimental",
      "fr": "émotionnel",
      "it": "Ricco di emozioni",
      "ru": "Эмоциональная",
    },
    {
      "en": "dark Ambient",
      "cn": "黑暗氛围",
      "es": "ambiente oscuro",
      "pt": "Ambiente escuro",
      "ko": "어두운 주변",
      "ja": "ダークアンビエント",
      'zh-Hans': "黑暗氛围",
      'zh-Hant': "黑暗氛圍",
      "de": "Dark Ambient",
      "fr": "ambiance sombre",
      "it": "Atmosfera oscura",
      "ru": "темная атмосфера",
    },
    {
      "en": "eerie",
      "cn": "阴森",
      "es": "misterioso",
      "pt": "estranho",
      "ko": "기분 나쁜",
      "ja": "不気味",
      'zh-Hans': "阴森",
      'zh-Hant': "陰森",
      "de": "unheimlich",
      "fr": "étrange",
      "it": "Bizzarro",
      "ru": "Странная",
    },
    {
      "en": "dreamy",
      "cn": "梦幻",
      "es": "soñador",
      "pt": "sonhador",
      "ko": "꿈꾸는 듯한",
      "ja": "夢のような",
      'zh-Hans': "梦幻",
      'zh-Hant': "夢幻",
      "de": "traumhaft",
      "fr": "rêveur",
      "it": "Onirico",
      "ru": "Мечтательная",
    },
    {
      "en": "melancholic",
      "cn": "忧郁",
      "es": "melancólico",
      "pt": "melancólico",
      "ko": "우울한",
      "ja": "メランコリック",
      'zh-Hans': "忧郁",
      'zh-Hant': "憂鬱",
      "de": "melancholisch",
      "fr": "mélancolique",
      "it": "melanconico",
      "ru": "Меланхоличная",
    },
    {
      "en": "chill",
      "cn": "冷静",
      "es": "enfriar",
      "pt": "frio",
      "ko": "냉기",
      "ja": "チル",
      'zh-Hans': "冷静",
      'zh-Hant': "冷靜",
      "de": "entspannt",
      "fr": "décontracté",
      "it": "Rilassante",
      "ru": "Расслабляющая",
    },
    {
      "en": "emo",
      "cn": "情绪化",
      "es": "emo",
      "pt": "emo",
      "ko": "이모",
      "ja": "エモ",
      'zh-Hans': "情绪化",
      'zh-Hant': "情緒化",
      "de": "emotional",
      "fr": "emo",
      "it": "Emotivo",
      "ru": "Эмоциональная"
    },
    {
      "en": "seriousness",
      "cn": "严肃",
      "es": "seriedad",
      "pt": "seriedade",
      "ko": "진지함",
      "ja": "真剣さ",
      'zh-Hans': "严肃",
      'zh-Hant': "嚴肅",
      "de": "Ernsthaftigkeit",
      "fr": "sérieux",
      "it": "serietà",
      "ru": "серьёзность",
    }
  ],
  map: {
    all: {
      "en": "all",
      "cn": "全部",
      "es": "total",
      "pt": "total",
      "ko": "모두",
      "ja": "すべて",
      'zh-Hans': "全部",
      'zh-Hant': "全部",
    },
    "relaxed": {
      "en": "relaxed",
      "cn": "放松",
      "es": "relajado",
      "pt": "relaxado",
      "ko": "편안한",
      "ja": "リラックスした",
      "zh-Hans": "放松",
      "zh-Hant": "放鬆",
      "de": "entspannt",
      "fr": "détendu",
      "it": "rilassato",
      "ru": "расслабленный"
    },
    "angry": {
      "en": "angry",
      "cn": "愤怒",
      "es": "enojado",
      "pt": "nervoso",
      "ko": "화난",
      "ja": "怒り",
      "zh-Hans": "愤怒",
      "zh-Hant": "憤怒",
      "de": "wütend",
      "fr": "en colère",
      "it": "arrabbiato",
      "ru": "злой"
    },
    "happy": {
      "en": "happy",
      "cn": "开心",
      "es": "feliz",
      "pt": "feliz",
      "ko": "행복하다",
      "ja": "ハッピー",
      "zh-Hans": "开心",
      "zh-Hant": "開心",
      "de": "glücklich",
      "fr": "heureux",
      "it": "Felice",
      "ru": "счастливый"
    },
    "energetic": {
      "en": "energetic",
      "cn": "充满活力",
      "es": "energético",
      "pt": "enérgico",
      "ko": "정력적인",
      "ja": "エネルギッシュな",
      "zh-Hans": "充满活力",
      "zh-Hant": "充滿活力",
      "de": "energiegeladen",
      "fr": "énergique",
      "it": "Energetico",
      "ru": "Энергичная"
    },
    "sad": {
      "en": "sad",
      "cn": "悲伤",
      "es": "triste",
      "pt": "triste",
      "ko": "슬픈",
      "ja": "悲しい",
      "zh-Hans": "悲伤",
      "zh-Hant": "悲傷",
      "de": "traurig",
      "fr": "triste",
      "it": "triste",
      "ru": "грустный"
    },
    "calm": {
      "en": "calm",
      "cn": "平静",
      "es": "calma",
      "pt": "calma",
      "ko": "침착한",
      "ja": "落ち着いた",
      "zh-Hans": "平静",
      "zh-Hant": "平靜",
      "de": "ruhig",
      "fr": "calme",
      "it": "calmo",
      "ru": "спокойный"
    },
    "inspired": {
      "en": "inspired",
      "cn": "激发灵感",
      "es": "inspirado",
      "pt": "inspirado",
      "ko": "탁월한",
      "ja": "インスパイヤされた",
      "zh-Hans": "激发灵感",
      "zh-Hant": "激發靈感",
      "de": "inspiriert",
      "fr": "inspiré",
      "it": "ispirato",
      "ru": "Вдохновляющая"
    },
    "mysterious": {
      "en": "mysterious",
      "cn": "神秘",
      "es": "misterioso",
      "pt": "misterioso",
      "ko": "신비한",
      "ja": "神秘的な",
      "zh-Hans": "神秘",
      "zh-Hant": "神秘",
      "de": "geheimnisvoll",
      "fr": "mystérieux",
      "it": "misterioso",
      "ru": "Загадочная"
    },
    "majestic": {
      "en": "majestic",
      "cn": "宏伟",
      "es": "majestuoso",
      "pt": "majestoso",
      "ko": "위엄 있는",
      "ja": "雄大な",
      "zh-Hans": "宏伟",
      "zh-Hant": "宏偉",
      "de": "majestätisch",
      "fr": "magnifique",
      "it": "magnifico",
      "ru": "Величественная"
    },
    "quirky": {
      "en": "quirky",
      "cn": "古怪",
      "es": "peculiar",
      "pt": "peculiar",
      "ko": "기발한",
      "ja": "風変わりな",
      "zh-Hans": "古怪",
      "zh-Hant": "古怪",
      "de": "grotesk",
      "fr": "bizarre",
      "it": "Bizzarro",
      "ru": "Причудливая"
    },
    "restless": {
      "en": "restless",
      "cn": "焦躁",
      "es": "inquieto",
      "pt": "agitado",
      "ko": "불안한",
      "ja": "落ち着きのない",
      "zh-Hans": "焦躁",
      "zh-Hant": "焦躁",
      "de": "unruhig",
      "fr": "agité",
      "it": "Inquieto",
      "ru": "Тревожная"
    },
    "romantic": {
      "en": "romantic",
      "cn": "浪漫",
      "es": "romantico",
      "pt": "romântico",
      "ko": "낭만적인",
      "ja": "ロマンチックな",
      "zh-Hans": "浪漫",
      "zh-Hant": "浪漫",
      "de": "romantisch",
      "fr": "romantique",
      "it": "romantico",
      "ru": "романтичный"
    },
    "dark": {
      "en": "dark",
      "cn": "黑暗",
      "es": "oscuro",
      "pt": "escuro",
      "ko": "어두운",
      "ja": "暗い",
      "zh-Hans": "黑暗",
      "zh-Hant": "黑暗",
      "de": "dunkel",
      "fr": "sombre",
      "it": "Oscuro",
      "ru": "Тёмная"
    },
    "warm": {
      "en": "warm",
      "cn": "温暖",
      "es": "cálido",
      "pt": "esquentar",
      "ko": "따뜻한",
      "ja": "暖かい",
      "zh-Hans": "温暖",
      "zh-Hant": "溫暖",
      "de": "warm",
      "fr": "chaleureux",
      "it": "caldo",
      "ru": "Тёплая"
    },
    "passionate": {
      "en": "passionate",
      "cn": "热情",
      "es": "apasionado",
      "pt": "apaixonado",
      "ko": "열렬한",
      "ja": "情熱的な",
      "zh-Hans": "热情",
      "zh-Hant": "熱情",
      "de": "leidenschaftlich",
      "fr": "passionné",
      "it": "Passionale",
      "ru": "Страстная"
    },
    "joyful": {
      "en": "joyful",
      "cn": "欢乐",
      "es": "alegre",
      "pt": "alegre",
      "ko": "즐거운",
      "ja": "楽しい",
      "zh-Hans": "欢乐",
      "zh-Hant": "歡樂",
      "de": "fröhlich",
      "fr": "joyeux",
      "it": "Felice",
      "ru": "Радостная"
    },
    "emotional": {
      "en": "emotional",
      "cn": "情感丰富",
      "es": "emocional",
      "pt": "emocional",
      "ko": "감정적인",
      "ja": "感情的",
      "zh-Hans": "情感丰富",
      "zh-Hant": "情感豐富",
      "de": "sentimental",
      "fr": "émotionnel",
      "it": "Ricco di emozioni",
      "ru": "Эмоциональная"
    },
    "dark Ambient": {
      "en": "dark Ambient",
      "cn": "黑暗氛围",
      "es": "ambiente oscuro",
      "pt": "Ambiente escuro",
      "ko": "어두운 주변",
      "ja": "ダークアンビエント",
      "zh-Hans": "黑暗氛围",
      "zh-Hant": "黑暗氛圍",
      "de": "Dark Ambient",
      "fr": "ambiance sombre",
      "it": "Atmosfera oscura",
      "ru": "темная атмосфера"
    },
    "eerie": {
      "en": "eerie",
      "cn": "阴森",
      "es": "misterioso",
      "pt": "estranho",
      "ko": "기분 나쁜",
      "ja": "不気味",
      "zh-Hans": "阴森",
      "zh-Hant": "陰森",
      "de": "unheimlich",
      "fr": "étrange",
      "it": "Bizzarro",
      "ru": "Странная"
    },
    "dreamy": {
      "en": "dreamy",
      "cn": "梦幻",
      "es": "soñador",
      "pt": "sonhador",
      "ko": "꿈꾸는 듯한",
      "ja": "夢のような",
      "zh-Hans": "梦幻",
      "zh-Hant": "夢幻",
      "de": "traumhaft",
      "fr": "rêveur",
      "it": "Onirico",
      "ru": "Мечтательная"
    },
    "melancholic": {
      "en": "melancholic",
      "cn": "忧郁",
      "es": "melancólico",
      "pt": "melancólico",
      "ko": "우울한",
      "ja": "メランコリック",
      "zh-Hans": "忧郁",
      "zh-Hant": "憂鬱",
      "de": "melancholisch",
      "fr": "mélancolique",
      "it": "melanconico",
      "ru": "Меланхоличная"
    },
    "chill": {
      "en": "chill",
      "cn": "冷静",
      "es": "enfriar",
      "pt": "frio",
      "ko": "냉기",
      "ja": "チル",
      "zh-Hans": "冷静",
      "zh-Hant": "冷靜",
      "de": "entspannt",
      "fr": "décontracté",
      "it": "Rilassante",
      "ru": "Расслабляющая"
    },
    "emo": {
      "en": "emo",
      "cn": "情绪化",
      "es": "emo",
      "pt": "emo",
      "ko": "이모",
      "ja": "エモ",
      "zh-Hans": "情绪化",
      "zh-Hant": "情緒化",
      "de": "emotional",
      "fr": "emo",
      "it": "Emotivo",
      "ru": "Эмоциональная"
    },
    "seriousness": {
      "en": "seriousness",
      "cn": "严肃",
      "es": "seriedad",
      "pt": "seriedade",
      "ko": "진지함",
      "ja": "真剣さ",
      'zh-Hans': "严肃",
      'zh-Hant': "嚴肅",
      "de": "Ernsthaftigkeit",
      "fr": "sérieux",
      "it": "serietà",
      "ru": "серьёзность",
    }
  },
};
// 生成-情绪-中文
export const EmotionalLabelDataCN = {
  list: [
    {
      "en": "开心",
      "cn": "开心",
    },
    {
      "en": "放松",
      "cn": "放松",
    },
    {
      "en": "浪漫",
      "cn": "浪漫",
    },
    {
      "en": "热烈",
      "cn": "热烈",
    },
    {
      "en": "平静",
      "cn": "平静",
    },
    {
      "en": "感动",
      "cn": "感动",
    },
    {
      "en": "温暖",
      "cn": "温暖",
    },
    {
      "en": "悲伤",
      "cn": "悲伤",
    },
    // {
    //   "en": "愤怒",
    //   "cn": "愤怒",
    // },
    {
      "en": "神秘",
      "cn": "神秘",
    },
    // {
    //   "en": "古怪",
    //   "cn": "古怪",
    // },
    {
      "en": "忧郁",
      "cn": "忧郁",
    },
    // {
    //   "en": "不安",
    //   "cn": "不安",
    // },
    // {
    //   "en": "严肃",
    //   "cn": "严肃",
    // },
  ],
  map: {
    开心: {
      "en": "开心",
      "cn": "开心",
    },
    放松: {
      "en": "放松",
      "cn": "放松",
    },
    浪漫: {
      "en": "浪漫",
      "cn": "浪漫",
    },
    热烈: {
      "en": "热烈",
      "cn": "热烈",
    },
    平静: {
      "en": "平静",
      "cn": "平静",
    },
    感动: {
      "en": "感动",
      "cn": "感动",
    },
    温暖: {
      "en": "温暖",
      "cn": "温暖",
    },
    悲伤: {
      "en": "悲伤",
      "cn": "悲伤",
    },
    // 愤怒: {
    //   "en": "愤怒",
    //   "cn": "愤怒",
    // },
    神秘: {
      "en": "神秘",
      "cn": "神秘",
    },
    // 古怪: {
    //   "en": "古怪",
    //   "cn": "古怪",
    // },
    忧郁: {
      "en": "忧郁",
      "cn": "忧郁",
    },
    // 不安: {
    //   "en": "不安",
    //   "cn": "不安",
    // },
    // 严肃: {
    //   "en": "严肃",
    //   "cn": "严肃",
    // },
  },
};
// 生成-情绪
export const EmotionalLabelData = EmotionalLabelDataEN

// 参考音乐-曲风-英文
export const ReferStyleLabelDataEN = {
  list: [
    {
      "en": "pop",
      "cn": "流行",
      "es": "estallido",
      "pt": "pop",
      "ko": "팝",
      "ja": "ポップ",
      'zh-Hans': "流行",
      'zh-Hant': "流行",
      "de": "Pop",
      "fr": "pop",
      "it": "pop",
      "ru": "Поп-музыка"
    },
    {
      "en": "rock",
      "cn": "摇滚",
      "es": "roca",
      "pt": "pedra",
      "ko": "록",
      "ja": "ロック",
      'zh-Hans': "摇滚",
      'zh-Hant': "搖滾",
      "de": "Rock",
      "fr": "rock",
      "it": "rock",
      "ru": "рок"
    },
    {
      "en": "hip-hop",
      "cn": "嘻哈",
      "es": "hip-hop",
      "pt": "hip-hop",
      "ko": "힙합",
      "ja": "ヒップホップ",
      'zh-Hans': "嘻哈",
      'zh-Hant': "嘻哈",
      "de": "Hip-Hop",
      "fr": "hip-hop",
      "it": "hip-hop",
      "ru": "хип-хоп"
    },
    {
      "en": "country",
      "cn": "乡村",
      "es": "país",
      "pt": "país",
      "ko": "컨트리",
      "ja": "カントリー",
      'zh-Hans': "乡村",
      'zh-Hant': "鄉村",
      "de": "Country",
      "fr": "country",
      "it": "country",
      "ru": "кантри"
    },
    {
      "en": "dance",
      "cn": "舞曲",
      "es": "bailar",
      "pt": "dança",
      "ko": "댄스",
      "ja": "ダンス",
      'zh-Hans': "舞曲",
      'zh-Hant': "舞曲",
      "de": "Dance",
      "fr": "danse",
      "it": "Musica da ballo",
      "ru": "Танцевальная музыка"
    },
    {
      "en": "electronic",
      "cn": "电子",
      "es": "electrónico",
      "pt": "eletrônico",
      "ko": "일렉트로닉",
      "ja": "エレクトロニック",
      'zh-Hans': "电子",
      'zh-Hant': "電子",
      "de": "Electro",
      "fr": "électronique",
      "it": "Elettronica",
      "ru": "Электроника"
    },
    {
      "en": "disco",
      "cn": "迪斯科",
      "es": "disco",
      "pt": "discoteca",
      "ko": "디스코",
      "ja": "ディスコ",
      'zh-Hans': "迪斯科",
      'zh-Hant': "迪斯科",
      "de": "Disko",
      "fr": "disco",
      "it": "disco",
      "ru": "диско"

    },
    {
      "en": "blues",
      "cn": "忧郁布鲁斯",
      "es": "blues",
      "pt": "blues",
      "ko": "블루스",
      "ja": "ブルース",
      'zh-Hans': "忧郁布鲁斯",
      'zh-Hant': "憂鬱布魯斯",
      "de": "Blues",
      "fr": "blues",
      "it": "blues",
      "ru": "Блюз"
    },
    {
      "en": "jazz",
      "cn": "爵士乐",
      "es": "jazz",
      "pt": "jazz",
      "ko": "재즈",
      "ja": "ジャズ",
      'zh-Hans': "爵士乐",
      'zh-Hant': "爵士樂",
      "de": "Jazz",
      "fr": "jazz",
      "it": "jazz",
      "ru": "джаз"
    },
    {
      "en": "folk",
      "cn": "民谣",
      "es": "gente",
      "pt": "povo",
      "ko": "포크포크",
      "ja": "フォーク",
      'zh-Hans': "民谣",
      'zh-Hant': "民謠",
      "de": "Volkslied",
      "fr": "folk",
      "it": "folk",
      "ru": "Фолк"
    },
    {
      "en": "latin",
      "cn": "拉丁流行",
      "es": "latín",
      "pt": "latim",
      "ko": "라틴",
      "ja": "ラテン",
      'zh-Hans': "拉丁流行",
      'zh-Hant': "拉丁流行",
      "de": "Latino",
      "fr": "latino",
      "it": "latina",
      "ru": "Латино"
    },
    {
      "en": "metal",
      "cn": "金属",
      "es": "metal",
      "pt": "metal",
      "ko": "메탈",
      "ja": "メタル",
      'zh-Hans': "金属",
      'zh-Hant': "金屬",
      "de": "Metall",
      "fr": "métal",
      "it": "metal",
      "ru": "Метал"
    },
    {
      "en": "punk",
      "cn": "朋克",
      "es": "punk",
      "pt": "punk",
      "ko": "펑크",
      "ja": "パンク",
      'zh-Hans': "朋克",
      'zh-Hant': "朋克",
      "de": "Punk",
      "fr": "punk",
      "it": "punk",
      "ru": "панк"
    },
    {
      "en": "r&b",
      "cn": "r&b",
      "es": "r&b",
      "pt": "r&b",
      "ko": "R&B",
      "ja": "R&B",
      'zh-Hans': "R&B",
      'zh-Hant': "R&B",
    },
    {
      "en": "soul",
      "cn": "灵魂",
      "es": "soul",
      "pt": "alma",
      "ko": "소울",
      "ja": "ソウル",
      'zh-Hans': "灵魂",
      'zh-Hant': "靈魂",
      "de": "Soul",
      "fr": "soul",
      "it": "soul",
      "ru": "Соул"
    },
    {
      "en": "funk",
      "cn": "放克",
      "es": "canguelo",
      "pt": "funk",
      "ko": "퓨크",
      "ja": "ファンク",
      'zh-Hans': "放克",
      'zh-Hant': "放克",
      "de": "Funk",
      "fr": "funk",
      "it": "funk",
      "ru": "фанк"
    },
    {
      "en": "reggae",
      "cn": "雷鬼",
      "es": "reggae",
      "pt": "reggae",
      "ko": "레게",
      "ja": "レゲエ",
      'zh-Hans': "雷鬼",
      'zh-Hant': "雷鬼",
      "de": "Reggae",
      "fr": "reggae",
      "it": "reggae",
      "ru": "регги"
    },
    {
      "en": "indie",
      "cn": "独立流行乐",
      "es": "independiente",
      "pt": "independente",
      "ko": "인디",
      "ja": "インディー",
      'zh-Hans': "独立流行乐",
      'zh-Hant': "獨立流行樂",
      "de": "Indie",
      "fr": "indie",
      "it": "Musica indipendente",
      "ru": "Инди-музыка"
    },
    {
      "en": "afrobeat",
      "cn": "非洲打击乐",
      "es": "afrobeat",
      "pt": "afrobeat",
      "ko": "아프로비트",
      "ja": "アフロビート",
      'zh-Hans': "非洲打击乐",
      'zh-Hant': "非洲打擊樂",
      "de": "Afrobeat",
      "fr": "afrobeat",
      "it": "Ritmi africani",
      "ru": "Африканские ритмы"
    },
    {
      "en": "classical",
      "cn": "古典",
      "es": "clásico",
      "pt": "clássico",
      "ko": "클래식",
      "ja": "クラシック",
      'zh-Hans': "古典",
      'zh-Hant': "古典",
      "de": "Klassik",
      "fr": "classique",
      "it": "Classica",
      "ru": "классика"
    },
    {
      "en": "world-music",
      "cn": "世界音乐",
      "es": "musica mundial",
      "pt": "música mundial",
      "ko": "월드 뮤직",
      "ja": "ワールドミュージック",
      'zh-Hans': "世界音乐",
      'zh-Hant': "世界音樂",
      "de": "Weltmusik",
      "fr": "musique du monde",
      "it": "Musica mondiale",
      "ru": "мировая музыка"
    },
    {
      "en": "experimental",
      "cn": "实验音乐",
      "pt": "experimental",
      "es": "experimental",
      "ko": "실험",
      "ja": "エクスペリメンタル",
      'zh-Hans': "实验音乐",
      'zh-Hant': "實驗音樂",
      "de": "Experimentell",
      "fr": "expérimental",
      "it": "Musica sperimentale",
      "ru": "Экспериментальная музыка"
    },
    // {
    //   "en": "children",
    //   "cn": "儿歌",
    //   "es": "niños",
    //   "pt": "crianças",
    //   "ko": "어린이",
    //   "ja": "キッズミュージック",
    //   'zh-Hans': "儿歌",
    //   'zh-Hant': "兒歌",
    //   "de": "Kinderlied",
    //   "fr": "musique pour enfants",
    //   "it": "Musica per bambini",
    //   "ru": "Детская музыка"
    // },
    {
      "en": "indian",
      "cn": "印度",
      "es": "indio",
      "pt": "indiano",
      "ko": "인디언",
      "ja": "インディアン",
      'zh-Hans': "印度",
      'zh-Hant': "印度",
      "de": "Indisch",
      "fr": "indien",
      "it": "Musica indiana",
      "ru": "индийская музыка"
    },
  ],
  map: {
    all: {
      "en": "all",
      "cn": "全部",
      "es": "total",
      "pt": "total",
      "ko": "모두",
      "ja": "すべて",
      'zh-Hans': "全部",
      'zh-Hant': "全部",
    },

    "pop": {
      "en": "pop",
      "cn": "流行",
      "es": "estallido",
      "pt": "pop",
      "ko": "팝",
      "ja": "ポップ",
      "zh-Hans": "流行",
      "zh-Hant": "流行",
      "de": "Pop",
      "fr": "pop",
      "it": "pop",
      "ru": "Поп-музыка"
    },
    "rock": {
      "en": "rock",
      "cn": "摇滚",
      "es": "roca",
      "pt": "pedra",
      "ko": "록",
      "ja": "ロック",
      "zh-Hans": "摇滚",
      "zh-Hant": "搖滾",
      "de": "Rock",
      "fr": "rock",
      "it": "rock",
      "ru": "рок"
    },
    "hip-hop": {
      "en": "hip-hop",
      "cn": "嘻哈",
      "es": "hip-hop",
      "pt": "hip-hop",
      "ko": "힙합",
      "ja": "ヒップホップ",
      "zh-Hans": "嘻哈",
      "zh-Hant": "嘻哈",
      "de": "Hip-Hop",
      "fr": "hip-hop",
      "it": "hip-hop",
      "ru": "хип-хоп"
    },
    "country": {
      "en": "country",
      "cn": "乡村",
      "es": "país",
      "pt": "país",
      "ko": "컨트리",
      "ja": "カントリー",
      "zh-Hans": "乡村",
      "zh-Hant": "鄉村",
      "de": "Country",
      "fr": "country",
      "it": "country",
      "ru": "кантри"
    },
    "dance": {
      "en": "dance",
      "cn": "舞曲",
      "es": "bailar",
      "pt": "dança",
      "ko": "댄스",
      "ja": "ダンス",
      "zh-Hans": "舞曲",
      "zh-Hant": "舞曲",
      "de": "Dance",
      "fr": "danse",
      "it": "Musica da ballo",
      "ru": "Танцевальная музыка"
    },
    "electronic": {
      "en": "electronic",
      "cn": "电子",
      "es": "electrónico",
      "pt": "eletrônico",
      "ko": "일렉트로닉",
      "ja": "エレクトロニック",
      "zh-Hans": "电子",
      "zh-Hant": "電子",
      "de": "Electro",
      "fr": "électronique",
      "it": "Elettronica",
      "ru": "Электроника"
    },
    "disco": {
      "en": "disco",
      "cn": "迪斯科",
      "es": "disco",
      "pt": "discoteca",
      "ko": "디스코",
      "ja": "ディスコ",
      "zh-Hans": "迪斯科",
      "zh-Hant": "迪斯科",
      "de": "Disko",
      "fr": "disco",
      "it": "disco",
      "ru": "диско"
    },
    "blues": {
      "en": "blues",
      "cn": "忧郁布鲁斯",
      "es": "blues",
      "pt": "blues",
      "ko": "블루스",
      "ja": "ブルース",
      "zh-Hans": "忧郁布鲁斯",
      "zh-Hant": "憂鬱布魯斯",
      "de": "Blues",
      "fr": "blues",
      "it": "blues",
      "ru": "Блюз"
    },
    "jazz": {
      "en": "jazz",
      "cn": "爵士乐",
      "es": "jazz",
      "pt": "jazz",
      "ko": "재즈",
      "ja": "ジャズ",
      "zh-Hans": "爵士乐",
      "zh-Hant": "爵士樂",
      "de": "Jazz",
      "fr": "jazz",
      "it": "jazz",
      "ru": "джаз"
    },
    "folk": {
      "en": "folk",
      "cn": "民谣",
      "es": "gente",
      "pt": "povo",
      "ko": "포크포크",
      "ja": "フォーク",
      "zh-Hans": "民谣",
      "zh-Hant": "民謠",
      "de": "Volkslied",
      "fr": "folk",
      "it": "folk",
      "ru": "Фолк"
    },
    "latin": {
      "en": "latin",
      "cn": "拉丁流行",
      "es": "latín",
      "pt": "latim",
      "ko": "라틴",
      "ja": "ラテン",
      "zh-Hans": "拉丁流行",
      "zh-Hant": "拉丁流行",
      "de": "Latino",
      "fr": "latino",
      "it": "latina",
      "ru": "Латино"
    },
    "metal": {
      "en": "metal",
      "cn": "金属",
      "es": "metal",
      "pt": "metal",
      "ko": "메탈",
      "ja": "メタル",
      "zh-Hans": "金属",
      "zh-Hant": "金屬",
      "de": "Metall",
      "fr": "métal",
      "it": "metal",
      "ru": "Метал"
    },
    "punk": {
      "en": "punk",
      "cn": "朋克",
      "es": "punk",
      "pt": "punk",
      "ko": "펑크",
      "ja": "パンク",
      "zh-Hans": "朋克",
      "zh-Hant": "朋克",
      "de": "Punk",
      "fr": "punk",
      "it": "punk",
      "ru": "панк"
    },
    "r&b": {
      "en": "r&b",
      "cn": "r&b",
      "es": "r&b",
      "pt": "r&b",
      "ko": "R&B",
      "ja": "R&B",
      "zh-Hans": "R&B",
      "zh-Hant": "R&B"
    },
    "soul": {
      "en": "soul",
      "cn": "灵魂",
      "es": "soul",
      "pt": "alma",
      "ko": "소울",
      "ja": "ソウル",
      "zh-Hans": "灵魂",
      "zh-Hant": "靈魂",
      "de": "Soul",
      "fr": "soul",
      "it": "soul",
      "ru": "Соул"
    },
    "funk": {
      "en": "funk",
      "cn": "放克",
      "es": "canguelo",
      "pt": "funk",
      "ko": "퓨크",
      "ja": "ファンク",
      "zh-Hans": "放克",
      "zh-Hant": "放克",
      "de": "Funk",
      "fr": "funk",
      "it": "funk",
      "ru": "фанк"
    },
    "reggae": {
      "en": "reggae",
      "cn": "雷鬼",
      "es": "reggae",
      "pt": "reggae",
      "ko": "레게",
      "ja": "レゲエ",
      "zh-Hans": "雷鬼",
      "zh-Hant": "雷鬼",
      "de": "Reggae",
      "fr": "reggae",
      "it": "reggae",
      "ru": "регги"
    },
    "indie": {
      "en": "indie",
      "cn": "独立流行乐",
      "es": "independiente",
      "pt": "independente",
      "ko": "인디",
      "ja": "インディー",
      "zh-Hans": "独立流行乐",
      "zh-Hant": "獨立流行樂",
      "de": "Indie",
      "fr": "indie",
      "it": "Musica indipendente",
      "ru": "Инди-музыка"
    },
    "afrobeat": {
      "en": "afrobeat",
      "cn": "非洲打击乐",
      "es": "afrobeat",
      "pt": "afrobeat",
      "ko": "아프로비트",
      "ja": "アフロビート",
      "zh-Hans": "非洲打击乐",
      "zh-Hant": "非洲打擊樂",
      "de": "Afrobeat",
      "fr": "afrobeat",
      "it": "Ritmi africani",
      "ru": "Африканские ритмы"
    },
    "classical": {
      "en": "classical",
      "cn": "古典",
      "es": "clásico",
      "pt": "clássico",
      "ko": "클래식",
      "ja": "クラシック",
      "zh-Hans": "古典",
      "zh-Hant": "古典",
      "de": "Klassik",
      "fr": "classique",
      "it": "Classica",
      "ru": "классика"
    },
    "world-music": {
      "en": "world-music",
      "cn": "世界音乐",
      "es": "musica mundial",
      "pt": "música mundial",
      "ko": "월드 뮤직",
      "ja": "ワールドミュージック",
      "zh-Hans": "世界音乐",
      "zh-Hant": "世界音樂",
      "de": "Weltmusik",
      "fr": "musique du monde",
      "it": "Musica mondiale",
      "ru": "мировая музыка"
    },
    "experimental": {
      "en": "experimental",
      "cn": "实验音乐",
      "pt": "experimental",
      "es": "experimental",
      "ko": "실험",
      "ja": "エクスペリメンタル",
      "zh-Hans": "实验音乐",
      "zh-Hant": "實驗音樂",
      "de": "Experimentell",
      "fr": "expérimental",
      "it": "Musica sperimentale",
      "ru": "Экспериментальная музыка"
    },
    "indian": {
      "en": "indian",
      "cn": "印度",
      "es": "indio",
      "pt": "indiano",
      "ko": "인디언",
      "ja": "インディアン",
      "zh-Hans": "印度",
      "zh-Hant": "印度",
      "de": "Indisch",
      "fr": "indien",
      "it": "Musica indiana",
      "ru": "индийская музыка"
    }
  }
}
// 参考音乐-曲风-中文
export const ReferStyleLabelDataCN = {
  list: [
    {
      "en": "流行",
      "cn": "流行",
    },
    {
      "en": "民谣",
      "cn": "民谣",
    },
    {
      "en": "摇滚",
      "cn": "摇滚",
    },
    {
      "en": "说唱",
      "cn": "说唱",
    },
    {
      "en": "电子音乐",
      "cn": "电子音乐",
    },
    {
      "en": "R&B/Soul",
      "cn": "R&B/Soul",
    },
    {
      "en": "布鲁斯",
      "cn": "布鲁斯",
    },
    {
      "en": "爵士",
      "cn": "爵士",
    },
    {
      "en": "雷鬼",
      "cn": "雷鬼",
    },
    {
      "en": "乡村",
      "cn": "乡村",
    },
    {
      "en": "古风",
      "cn": "古风",
    },
    {
      "en": "世界音乐",
      "cn": "世界音乐",
    },
    {
      "en": "DJ舞曲",
      "cn": "DJ舞曲",
    },
  ],
  map: {
    流行: {
      "en": "流行",
      "cn": "流行",
    },
    民谣: {
      "en": "民谣",
      "cn": "民谣",
    },
    摇滚: {
      "en": "摇滚",
      "cn": "摇滚",
    },
    说唱: {
      "en": "说唱",
      "cn": "说唱",
    },
    电子音乐: {
      "en": "电子音乐",
      "cn": "电子音乐",
    },
    "R&B/Soul": {
      "en": "R&B/Soul",
      "cn": "R&B/Soul",
    },
    布鲁斯: {
      "en": "布鲁斯",
      "cn": "布鲁斯",
    },
    爵士: {
      "en": "爵士",
      "cn": "爵士",
    },
    雷鬼: {
      "en": "雷鬼",
      "cn": "雷鬼",
    },
    乡村: {
      "en": "乡村",
      "cn": "乡村",
    },
    古风: {
      "en": "古风",
      "cn": "古风",
    },
    世界音乐: {
      "en": "世界音乐",
      "cn": "世界音乐",
    },
    DJ舞曲: {
      "en": "DJ舞曲",
      "cn": "DJ舞曲",
    },
  },
};
// 参考音乐-曲风
export const ReferStyleLabelData = ReferStyleLabelDataEN

// 参考音乐-情绪-英文
export const ReferEmotionalLabelDataEN = {
  list: [
    {
      "en": "happy",
      "cn": "欢快",
      "es": "feliz",
      "pt": "feliz",
      "ko": "기쁨",
      "ja": "幸せ",
      'zh-Hans': "欢快",
      'zh-Hant': "快樂",
      "de": "glücklich",
      "fr": "heureux",
      "it": "Felice",
      "ru": "счастливый",
    },
    {
      "en": "relaxed",
      "cn": "轻松",
      "es": "relajado",
      "pt": "relaxado",
      "ko": "편안함",
      "ja": "リラックスした",
      'zh-Hans': "轻松",
      'zh-Hant': "輕鬆",
      "de": "entspannt",
      "fr": "détendu",
      "it": "rilassato",
      "ru": "расслабленный",
    },
    {
      "en": "romantic",
      "cn": "浪漫",
      "es": "romantico",
      "pt": "romântico",
      "ko": "낭만적인",
      "ja": "ロマンチック",
      'zh-Hans': "浪漫",
      'zh-Hant': "浪漫",
      "de": "romantisch",
      "fr": "romantique",
      "it": "romantico",
      "ru": "романтический",
    },
    {
      "en": "energetic",
      "cn": "活力",
      "es": "energético",
      "pt": "enérgico",
      "ko": "에너제틱",
      "ja": "エネルギッシュ",
      'zh-Hans': "活力",
      'zh-Hant': "活力",
      "de": "energiegeladen",
      "fr": "énergique",
      "it": "energetico",
      "ru": "энергичный",
    },
    {
      "en": "calm",
      "cn": "冷静",
      "es": "calma",
      "pt": "calma",
      "ko": "차분한",
      "ja": "落ち着いた",
      'zh-Hans': "冷静",
      'zh-Hant': "冷靜",
      "de": "ruhig",
      "fr": "calme",
      "it": "calmo",
      "ru": "спокойный",
    },
    {
      "en": "inspired",
      "cn": "鼓舞人心",
      "es": "inspirado",
      "pt": "inspirado",
      "ko": "영감을 받은",
      "ja": "感化された",
      'zh-Hans': "鼓舞人心",
      'zh-Hant': "鼓舞人心",
      "de": "inspiriert",
      "fr": "inspiré",
      "it": "ispirato",
      "ru": "Вдохновляющая",
    },
    {
      "en": "warm",
      "cn": "温暖",
      "es": "cálido",
      "pt": "esquentar",
      "ko": "따뜻한",
      "ja": "温かい",
      'zh-Hans': "温暖",
      'zh-Hant': "溫暖",
      "de": "warm",
      "fr": "chaleureux",
      "it": "caldo",
      "ru": "Тёплая",
    },
    {
      "en": "angry",
      "cn": "愤怒",
      "es": "enojado",
      "pt": "nervoso",
      "ko": "화나게",
      "ja": "怒り",
      'zh-Hans': "愤怒",
      'zh-Hant': "憤怒",
      "de": "wütend",
      "fr": "en colère",
      "it": "arrabbiato",
      "ru": "злой",
    },
    {
      "en": "mysterious",
      "cn": "神秘",
      "es": "misterioso",
      "pt": "misterioso",
      "ko": "신비한",
      "ja": "神秘的",
      'zh-Hans': "神秘",
      'zh-Hant': "神秘",
      "de": "mysteriös",
      "fr": "mystérieux",
      "it": "misterioso",
      "ru": "Загадочная",
    },
    {
      "en": "quirky",
      "cn": "古怪",
      "es": "peculiar",
      "pt": "peculiar",
      "ko": "꾀바르게",
      "ja": "奇妙な",
      'zh-Hans': "古怪",
      'zh-Hant': "古怪",
      "de": "grotesk",
      "fr": "bizarre",
      "it": "Bizzarro",
      "ru": "Причудливая",
    },
    {
      "en": "dark",
      "cn": "黑暗",
      "es": "oscuro",
      "pt": "escuro",
      "ko": "다크",
      "ja": "ダーク",
      'zh-Hans': "黑暗",
      'zh-Hant': "黑暗",
      "de": "dunkel",
      "fr": "sombre",
      "it": "Oscuro",
      "ru": "Тёмная",
    },
    {
      "en": "majestic",
      "cn": "雄伟",
      "es": "majestuoso",
      "pt": "majestoso",
      "ko": "장엄함",
      "ja": "荘厳な",
      'zh-Hans': "雄伟",
      'zh-Hant': "雄偉",
      "de": "majestätisch",
      "fr": "magnifique",
      "it": "magnifico",
      "ru": "Величественная",
    },
    {
      "en": "restless",
      "cn": "不安",
      "es": "inquieto",
      "pt": "agitado",
      "ko": "불안한",
      "ja": "不安",
      'zh-Hans': "不安",
      'zh-Hant': "不安",
      "de": "unruhig",
      "fr": "agité",
      "it": "Inquieto",
      "ru": "Тревожная",
    },
    {
      "en": "sad",
      "cn": "悲伤",
      "es": "triste",
      "pt": "triste",
      "ko": "슬픔",
      "ja": "悲しい",
      'zh-Hans': "悲伤",
      'zh-Hant': "悲傷",
      "de": "traurig",
      "fr": "triste",
      "it": "triste",
      "ru": "грустный",
    },
  ],
  map: {
    all: {
      "en": "all",
      "cn": "全部",
      "es": "total",
      "pt": "total",
      "ko": "모두",
      "ja": "すべて",
      'zh-Hans': "全部",
      'zh-Hant': "全部",
    },
    "happy": {
      "en": "happy",
      "cn": "欢快",
      "es": "feliz",
      "pt": "feliz",
      "ko": "기쁨",
      "ja": "幸せ",
      "zh-Hans": "欢快",
      "zh-Hant": "快樂",
      "de": "glücklich",
      "fr": "heureux",
      "it": "Felice",
      "ru": "счастливый"
    },
    "relaxed": {
      "en": "relaxed",
      "cn": "轻松",
      "es": "relajado",
      "pt": "relaxado",
      "ko": "편안함",
      "ja": "リラックスした",
      "zh-Hans": "轻松",
      "zh-Hant": "輕鬆",
      "de": "entspannt",
      "fr": "détendu",
      "it": "rilassato",
      "ru": "расслабленный"
    },
    "romantic": {
      "en": "romantic",
      "cn": "浪漫",
      "es": "romantico",
      "pt": "romântico",
      "ko": "낭만적인",
      "ja": "ロマンチック",
      "zh-Hans": "浪漫",
      "zh-Hant": "浪漫",
      "de": "romantisch",
      "fr": "romantique",
      "it": "romantico",
      "ru": "романтический"
    },
    "energetic": {
      "en": "energetic",
      "cn": "活力",
      "es": "energético",
      "pt": "enérgico",
      "ko": "에너제틱",
      "ja": "エネルギッシュ",
      "zh-Hans": "活力",
      "zh-Hant": "活力",
      "de": "energiegeladen",
      "fr": "énergique",
      "it": "energetico",
      "ru": "энергичный"
    },
    "calm": {
      "en": "calm",
      "cn": "冷静",
      "es": "calma",
      "pt": "calma",
      "ko": "차분한",
      "ja": "落ち着いた",
      "zh-Hans": "冷静",
      "zh-Hant": "冷靜",
      "de": "ruhig",
      "fr": "calme",
      "it": "calmo",
      "ru": "спокойный"
    },
    "inspired": {
      "en": "inspired",
      "cn": "鼓舞人心",
      "es": "inspirado",
      "pt": "inspirado",
      "ko": "영감을 받은",
      "ja": "感化された",
      "zh-Hans": "鼓舞人心",
      "zh-Hant": "鼓舞人心",
      "de": "inspiriert",
      "fr": "inspiré",
      "it": "ispirato",
      "ru": "Вдохновляющая"
    },
    "warm": {
      "en": "warm",
      "cn": "温暖",
      "es": "cálido",
      "pt": "esquentar",
      "ko": "따뜻한",
      "ja": "温かい",
      "zh-Hans": "温暖",
      "zh-Hant": "溫暖",
      "de": "warm",
      "fr": "chaleureux",
      "it": "caldo",
      "ru": "Тёплая"
    },
    "angry": {
      "en": "angry",
      "cn": "愤怒",
      "es": "enojado",
      "pt": "nervoso",
      "ko": "화나게",
      "ja": "怒り",
      "zh-Hans": "愤怒",
      "zh-Hant": "憤怒",
      "de": "wütend",
      "fr": "en colère",
      "it": "arrabbiato",
      "ru": "злой"
    },
    "mysterious": {
      "en": "mysterious",
      "cn": "神秘",
      "es": "misterioso",
      "pt": "misterioso",
      "ko": "신비한",
      "ja": "神秘的",
      "zh-Hans": "神秘",
      "zh-Hant": "神秘",
      "de": "mysteriös",
      "fr": "mystérieux",
      "it": "misterioso",
      "ru": "Загадочная"
    },
    "quirky": {
      "en": "quirky",
      "cn": "古怪",
      "es": "peculiar",
      "pt": "peculiar",
      "ko": "꾀바르게",
      "ja": "奇妙な",
      "zh-Hans": "古怪",
      "zh-Hant": "古怪",
      "de": "grotesk",
      "fr": "bizarre",
      "it": "Bizzarro",
      "ru": "Причудливая"
    },
    "dark": {
      "en": "dark",
      "cn": "黑暗",
      "es": "oscuro",
      "pt": "escuro",
      "ko": "다크",
      "ja": "ダーク",
      "zh-Hans": "黑暗",
      "zh-Hant": "黑暗",
      "de": "dunkel",
      "fr": "sombre",
      "it": "Oscuro",
      "ru": "Тёмная"
    },
    "majestic": {
      "en": "majestic",
      "cn": "雄伟",
      "es": "majestuoso",
      "pt": "majestoso",
      "ko": "장엄함",
      "ja": "荘厳な",
      "zh-Hans": "雄伟",
      "zh-Hant": "雄偉",
      "de": "majestätisch",
      "fr": "magnifique",
      "it": "magnifico",
      "ru": "Величественная"
    },
    "restless": {
      "en": "restless",
      "cn": "不安",
      "es": "inquieto",
      "pt": "agitado",
      "ko": "불안한",
      "ja": "不安",
      "zh-Hans": "不安",
      "zh-Hant": "不安",
      "de": "unruhig",
      "fr": "agité",
      "it": "Inquieto",
      "ru": "Тревожная"
    },
    "sad": {
      "en": "sad",
      "cn": "悲伤",
      "es": "triste",
      "pt": "triste",
      "ko": "슬픔",
      "ja": "悲しい",
      "zh-Hans": "悲伤",
      "zh-Hant": "悲傷",
      "de": "traurig",
      "fr": "triste",
      "it": "triste",
      "ru": "грустный"
    }

  },
};
// 参考音乐-情绪-中文

export const ReferEmotionalLabelDataCN = {
  list: [
    {
      "en": "愤怒",
      "cn": "愤怒",
    },
    {
      "en": "放松",
      "cn": "放松",
    },
    {
      "en": "开心",
      "cn": "开心",
    },
    {
      "en": "黑暗",
      "cn": "黑暗",
    },
    {
      "en": "热烈",
      "cn": "热烈",
    },
    {
      "en": "神秘",
      "cn": "神秘",
    },
    {
      "en": "严肃",
      "cn": "严肃",
    },
    {
      "en": "古怪",
      "cn": "古怪",
    },
    {
      "en": "不安",
      "cn": "不安",
    },
    {
      "en": "浪漫",
      "cn": "浪漫",
    },
    {
      "en": "悲伤",
      "cn": "悲伤",
    },
    {
      "en": "温暖",
      "cn": "温暖",
    },
  ],
  map: {
    愤怒: {
      "en": "愤怒",
      "cn": "愤怒",
    },
    放松: {
      "en": "放松",
      "cn": "放松",
    },
    开心: {
      "en": "开心",
      "cn": "开心",
    },
    黑暗: {
      "en": "黑暗",
      "cn": "黑暗",
    },
    热烈: {
      "en": "热烈",
      "cn": "热烈",
    },
    神秘: {
      "en": "神秘",
      "cn": "神秘",
    },
    严肃: {
      "en": "严肃",
      "cn": "严肃",
    },
    古怪: {
      "en": "古怪",
      "cn": "古怪",
    },
    不安: {
      "en": "不安",
      "cn": "不安",
    },
    浪漫: {
      "en": "浪漫",
      "cn": "浪漫",
    },
    悲伤: {
      "en": "悲伤",
      "cn": "悲伤",
    },
    温暖: {
      "en": "温暖",
      "cn": "温暖",
    },
  },
};
// 参考音乐-情绪
export const ReferEmotionalLabelData = ReferEmotionalLabelDataEN

export const ReferScenarioLabelDataEN = {
  list: [
    {
      "en": "Vlog",
      "cn": "Vlog",
      "es": "Vlog",
      "pt": "Vlog",
      "ko": "브이로그",
      "ja": "ブログ",
      'zh-Hans': "Vlog",
      'zh-Hant': "Vlog",
      "de": "Vlog",
      "fr": "Vlog",
      "it": "Vlog",
      "ru": "Влог",
    },
    {
      "en": "Film/Animation",
      "cn": "电影/动画",
      "es": "Película/Animación",
      "pt": "Filme/Animação",
      "ko": "영화/애니메이션",
      "ja": "映画/アニメーション",
      'zh-Hans': "电影/动画",
      'zh-Hant': "電影/動畫",
      "de": "Film/Animation",
      "fr": "Film/Animation",
      "it": "Film/Animazione",
      "ru": "Фильм/Анимация",
    },
    {
      "en": "Ads/Branding",
      "cn": "广告/品牌",
      "es": "Anuncios/Marca",
      "pt": "Anúncios/Marca",
      "ko": "광고/브랜딩",
      "ja": "広告/ブランディング",
      'zh-Hans': "广告/品牌",
      'zh-Hant': "廣告/品牌",
      "de": "Werbung/Branding",
      "fr": "Publicité/Image de marque",
      "it": "Pubblicità/Branding",
      "ru": "Реклама/Брендинг",
    },
    {
      "en": "Broadcast",
      "cn": "广播",
      "es": "Transmisión",
      "pt": "Transmissão",
      "ko": "방송",
      "ja": "放送",
      'zh-Hans': "广播",
      'zh-Hant': "廣播",
      "de": "Rundfunk",
      "fr": "Diffusion",
      "it": "Trasmissione",
      "ru": "Трансляция",
    },
    {
      "en": "Event",
      "cn": "活动",
      "es": "Evento",
      "pt": "Evento",
      "ko": "이벤트",
      "ja": "イベント",
      'zh-Hans': "活动",
      'zh-Hant': "活動",
      "de": "Veranstaltung",
      "fr": "Événement",
      "it": "Evento",
      "ru": "Мероприятие",
    },
    {
      "en": "Focus",
      "cn": "专注",
      "es": "Enfocar",
      "pt": "Foco",
      "ko": "집중하다",
      "ja": "集中",
      'zh-Hans': "专注",
      'zh-Hant': "專注",
      "de": "Fokus",
      "fr": "Se concentrer",
      "it": "Messa a fuoco",
      "ru": "Фокус",
    },
  ],
  map: {
    "Vlog": {
      "en": "Vlog",
      "cn": "Vlog",
      "es": "Vlog",
      "pt": "Vlog",
      "ko": "브이로그",
      "ja": "ブログ",
      'zh-Hans': "Vlog",
      'zh-Hant': "Vlog",
      "de": "Vlog",
      "fr": "Vlog",
      "it": "Vlog",
      "ru": "Влог",
    },
    "Film/Animation": {
      "en": "Film/Animation",
      "cn": "电影/动画",
      "es": "Película/Animación",
      "pt": "Filme/Animação",
      "ko": "영화/애니메이션",
      "ja": "映画/アニメーション",
      'zh-Hans': "电影/动画",
      'zh-Hant': "電影/動畫",
      "de": "Film/Animation",
      "fr": "Film/Animation",
      "it": "Film/Animazione",
      "ru": "Фильм/Анимация",
    },
    "Ads/Branding": {
      "en": "Ads/Branding",
      "cn": "广告/品牌",
      "es": "Anuncios/Marca",
      "pt": "Anúncios/Marca",
      "ko": "광고/브랜딩",
      "ja": "広告/ブランディング",
      'zh-Hans': "广告/品牌",
      'zh-Hant': "廣告/品牌",
      "de": "Werbung/Branding",
      "fr": "Publicité/Image de marque",
      "it": "Pubblicità/Branding",
      "ru": "Реклама/Брендинг",
    },
    "Broadcast": {
      "en": "Broadcast",
      "cn": "广播",
      "es": "Transmisión",
      "pt": "Transmissão",
      "ko": "방송",
      "ja": "放送",
      'zh-Hans': "广播",
      'zh-Hant': "廣播",
      "de": "Rundfunk",
      "fr": "Diffusion",
      "it": "Trasmissione",
      "ru": "Трансляция",
    },
    "Event": {
      "en": "Event",
      "cn": "活动",
      "es": "Evento",
      "pt": "Evento",
      "ko": "이벤트",
      "ja": "イベント",
      'zh-Hans': "活动",
      'zh-Hant': "活動",
      "de": "Veranstaltung",
      "fr": "Événement",
      "it": "Evento",
      "ru": "Мероприятие",
    },
    "Focus": {
      "en": "Focus",
      "cn": "专注",
      "es": "Enfocar",
      "pt": "Foco",
      "ko": "집중하다",
      "ja": "集中",
      'zh-Hans': "专注",
      'zh-Hant': "專注",
      "de": "Fokus",
      "fr": "Se concentrer",
      "it": "Messa a fuoco",
      "ru": "Фокус",
    },
  }

}

export const ReferScenarioLabelData = ReferScenarioLabelDataEN


export const getEnOptions = (list,language) => {
  return list.map((item) => {
    return {
      label: item[language],
      value: item.en,
    };
  });
};

export const getSelectValue = (list, map, language) => {
  return list
    ?.map((item) => {
      item = item.toLocaleLowerCase();
      if (map[item]) {
        return {
          ...map[item],
          value: map[item].value ?? map[item].en,
          label:
            map[item].label ?? map[item][language],
        };
      } else {
        return null;
      }
    })
    .filter((item) => !!item);
};

// let a = ``.replace(/”|“/g, "").replace(/、|,/g, ",").split(",");
// let obj = {};
// [].map((item, index) => {
//   obj[item] = {
//     "en": item,
//     "cn": a[index],
//   };
//   return {
//     "en": item,
//     "cn": a[index],
//   };
// });


export const getRenderLabel = (list, map, language) => {
  return list?.reduce((res, item) => {
    item = item.toLocaleLowerCase();
    if (map[item]?.[language]) {
      res.push(map[item][language]);
    }
    return res;
  }, []);
}

export default {
  getSegTypes,
  EmotionalLabelData,
  StyleLabelData,
  getEnOptions,
  getSelectValue,
  getRenderLabel,
};
